<template>
    <div class="pt-3" :class="((me) ? '' : 'p-5')">
        <v-dialog max-width="800" :value="!!qualificationLead" @input="value => { if (!value) qualificationLead = null }">
          <div v-if="qualificationLead" class="bg-white p-6 rounded-lg">
            <public-lead-details :key="qualificationLead.id" :lead="qualificationLead" :report-uuid="getUUID()" initial-tab="Qualification" @saved="onPublicQualificationSaved" @close="qualificationLead = null">
              <p>{{ qualificationLead.job_type }}</p>
              <p>{{ qualificationLead.ai_provided_phone_number || qualificationLead.customer_phone_number }}</p>
              <p>{{ qualificationLead.summary }}</p>
            </public-lead-details>
          </div>
        </v-dialog>

        <div v-if="shouldShowChatConversation" @click.self="shouldShowChatConversation = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
                <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                    <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">
<public-lead-details :key="ai_messages_lead.id" :lead="ai_messages_lead" :report-uuid="getUUID()" @saved="onPublicQualificationSaved" @close="shouldShowChatConversation = false">


                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                    </div>

                    <div style="clear: both;"></div>

                    <div>
                        <div v-if="loading_chat_conversation" :class="'w-full mb-3'">
                            <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                        </div>
                        <div class="flex flex-row flex-wrap" v-else>
                            <div class="w-full">
                                <div id="chat-dialog-messages-list" style="max-height: 500px; overflow: auto;">
                                    <div>
                                        <b-list-group>
                                            <b-list-group-item

                                                v-for="(item, index) in bland_transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.role == 'assistant' || !item.role"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.role == 'user'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.custom_name">
                                                        <span class="mr-auto primary-color text-bold">{{ item.custom_name }}</span>
                                                    </span>
                                                    <span v-else>
                                                        <span v-if="!item.role" class="mr-auto primary-color text-bold">{{ company_name }}</span>
                                                        <span v-else>
                                                            <span v-if="item.role == 'assistant'" class="mr-auto primary-color text-bold">AI Agent</span>
                                                            <span v-else class="mr-auto warning-color text-bold">Customer</span>
                                                        </span>
                                                    </span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item, item.timestamp || item.created_at) }} . </span>
                                                    <div class="text-sm">{{ item.content }} </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>

                                <div class="mt-4 -mb-12">
                                    <v-text-field
                                        clearable
                                        outlined
                                        dense
                                        hide-details
                                        label="Reply"
                                        v-model="new_ai_message"

                                        class="white border border-white"
                                    ></v-text-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    </public-lead-details>
</div>

                    <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="shouldShowChatConversation = false">
                            CLOSE
                        </button>

                        <button
                                class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                                :class="{ spinner: sendingAiMessage }"
                                @click="sendAiReply()"
                                :disabled="!new_ai_message"
                        >
                            SEND
                        </button>

                        <div style="float: right; padding-right: 30px; padding-top: 6px;">
                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                        </div>

                        <div class="clearfix"></div>

                    <div class="clearfix"></div>

                    </div>

                </div>
            </div>

        <div v-if="showBlandRecording" @click.self="showBlandRecording = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-2/3 lg:w-2/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">
<public-lead-details :key="ai_messages_lead.id" :lead="ai_messages_lead" :report-uuid="getUUID()" @saved="onPublicQualificationSaved" @close="showBlandRecording = false">


                    <div class="float-right -mb-4" style="position: relative;">
                        <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->

                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="translateTexts('bland', 'spanish')">
                            <i class="mdi mdi-text-box-edit-outline"></i> TRANSLATE TO ENGLISH
                        </button>
                    </div>

                    <div class="float-left">
                        <span v-if="ai_messages_lead.customer_name">{{ ai_messages_lead.customer_name }} - </span>
                        <span v-if="ai_messages_lead.job_type">{{ ai_messages_lead.job_type }} - </span>
                        <span>{{ ai_messages_lead.ai_provided_phone_number || ai_messages_lead.customer_phone_number || ai_messages_lead.tracking_number || 'No phone number' }}</span>
                    </div>

                    <div class="float-right -mb-4" style="position: relative;">
                        <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="ai_messages_lead.show_ai_feedback = !ai_messages_lead.show_ai_feedback || true;">
                            <i class="mdi mdi-robot-outline"></i>
                            &nbsp;
                            <span v-if="ai_messages_lead.ai_feedback_urgent">🚨</span>
                            &nbsp;
                            <strong v-if="ai_messages_lead.ai_feedback">AI FEEDBACK</strong><span v-else="">AI FEEDBACK</span>
                        </button>

                        <div v-show="ai_messages_lead.show_ai_feedback" style="position: absolute; background: #FFFFFF; padding: 10px; border: solid 1px #CCCCCC; width: 250px; z-index: 1; margin-top: 40px;">
                            <textarea v-model="ai_messages_lead.ai_feedback" style="padding: 10px; width: 100%; height: 200px; border: solid 1px #CCCCCC; border-radius: 5px;"></textarea>

                            <br />

                            <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_feedback_urgent" label="Urgent"></v-switch>

                            <br />

                            <button class="rg-dialog-button-save rounded text-white text-xs text-bold focus:outline-none py-2 px-4 w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="saveAiFeedback(ai_messages_lead)">
                                SAVE
                            </button>

                            <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 w-full w-full mb-2" :class="{'spinner': savingAiFeedback}" @click="ai_messages_lead.show_ai_feedback = false;">
                                CLOSE
                            </button>
                        </div>
                    </div>

                <div style="clear: both; padding-top: 10px;"></div>

                <div>
                    <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                        <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                    </div>
                    <div class="flex flex-row flex-wrap" v-else>
                        <div class="w-full mb-4">
                            <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                            <div id="bl-audio-el-here"></div>
                        </div>
                        <div class="w-full">
                            <hr />
                            <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                    <br />
                                    No transcription available.
                                </div>
                                <div v-else>
                                    <div v-if="bland_recording_data.lead_type == 'PHONE_CALL'">
                                        <div class="flex flex-row flex-wrap w-full">
                                            <div :class="'w-full lg:w-1/2'">
                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                <br />
                                                <div>
                                                    <b-list-group>
                                                        <b-list-group-item
                                                            v-for="(item, index) in bland_recording_data.transcription" :key="index"
                                                    
                                                                class="d-flex align-items-center mb-4 pb-4"
                                                                style="border: none; border-bottom: solid 1px #ededed;"
                                                                v-if="index !== 'messages'"
                                                        >
                                                            <b-avatar v-if="item.speaker == 'A'"
                                                                    text="S1"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <b-avatar v-if="item.speaker == 'B'"
                                                                    text="S2"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <div>
                                                                <span v-if="item.speaker == 'A'" class="mr-auto primary-color text-bold">AI</span>
                                                                <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, bland_recording_data.transcription[0].start) }} . </span>
                                                                <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                <div class="text-sm">{{ item.text }}</div>
                                                            </div>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                            <div :class="'w-full lg:w-1/2 pl-3'">
                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Summary</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.summary || "No summary found." }}</div>

                                                <!-- <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Sentiment</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.sentiment || "UNKNOWN" }}</div>

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Topics Discussed</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.topics_discussed || "No topics discussed." }}</div>

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Issues Raised</div>

                                                <div style="font-size: 12px;">{{ bland_recording_data.issues_raised || "No issues raised." }}</div> -->

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Customer Information</div>

                                                <div style="font-size: 12px;">
                                                    <strong>Customer's name:</strong> {{ bland_recording_data.customer_name || "-" }}
                                                    <br />
                                                    <strong>Customer's email:</strong> {{ bland_recording_data.customer_email || "-" }}
                                                    <br />
                                                    <strong>Customer's phone:</strong> {{ bland_recording_data.ai_provided_phone_number || "-" }}
                                                    <br />
                                                    <strong>Service needed:</strong> {{ bland_recording_data.job_type || "-" }}
                                                    <br /><br />
                                                    <strong>Call ended by:</strong> {{ bland_recording_data.call_ended_by || "-" }}
                                                </div>

                                                <!--<div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Analysis</div>

                                                <div v-if="bland_recording_data.analysis" style="font-size: 12px;">
                                                    <div v-for="(item, index) in bland_recording_data.analysis" :key="'variable-' + index">
                                                        <strong>{{ index }}: </strong> {{ item }} <br />
                                                    </div>
                                                </div>
                                                <div v-else style="font-size: 12px;">No analysis detected.</div>-->

                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Variables</div>

                                                <div v-if="bland_recording_data.variables" style="font-size: 12px;">
                                                    <div v-for="(item, index) in bland_recording_data.variables" :key="'variable-' + index">
                                                        <strong>{{ index }}: </strong> {{ item }} <br />
                                                    </div>
                                                </div>
                                                <div v-else style="font-size: 12px;">No variables.</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else>
                                        <b-list-group>
                                            <b-list-group-item
                                                v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >

                                                <b-avatar v-if="(!item.is_bland && item.sender != 'bot') || item.is_person"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="(item.is_bland || item.sender == 'bot') && !item.is_person"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.is_person" class="mr-auto primary-color text-bold">{{ company_name }}</span>
                                                    <span v-if="(item.is_bland || item.sender == 'bot') && !item.is_person" class="mr-auto primary-color text-bold">AI Agent</span>
                                                    <span v-if="!item.is_bland && item.sender != 'bot' && !item.is_person" class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item, item.timestamp) }} . </span>
                                                    <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                    <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                    <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                    <div class="text-sm">
                                                        {{ item.message }}
                                                    </div>
                                                </div>
                                            </b-list-group-item>
                                        </b-list-group>
                                    </div>
                                </div>
                            </div>

                            <div v-show="bland_recording_data.transcription.messages" class="mt-4 -mb-12">
                                <v-text-field
                                    clearable
                                    outlined
                                    dense
                                    hide-details
                                    label="Reply"
                                    v-model="new_ai_message"

                                    class="white border border-white"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>

                </public-lead-details>
</div>

                <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showBlandRecording = false">
                    CLOSE
                </button>

                <button
                        class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                        :class="{ spinner: sendingAiMessage }"
                        @click="sendAiReply()"
                        :disabled="!new_ai_message"
                >
                    SEND
                </button>

                <div style="float: right; padding-right: 30px; padding-top: 6px;">
                    <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                </div>

                <div class="clearfix"></div>

                </div>

            </div>
        </div>

        <div v-if="showLsaRecordings" @click.self="showLsaRecordings = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">
<public-lead-details :key="lsa_item.id" :lead="lsa_item" :report-uuid="getUUID()" @saved="onPublicQualificationSaved" @close="showLsaRecordings = false">


                <div class="float-right -mb-4" style="position: relative;">
                    <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                </div>

                <div style="clear: both;"></div>

                <div>
                    <div v-if="loading_lsa_recordings" :class="'w-full mb-3'">
                        <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                    </div>
                    <div class="flex flex-row flex-wrap" v-else>
                        <div class="w-full mb-4">
                            <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                            <div id="lsa-audio-el-here"></div>

                            <div class="bg-blue-100 border-l-4 border-blue-500 text-blue-700 p-4 mb-4" role="alert">
                                <div>According to Google's policy, you must be logged in to your LSA account in this browser. Please make sure you are logged in on <a href="https://ads.google.com/localservices" target="lsa-account-login">https://ads.google.com/localservices</a> in order to play the recordings in your software.</div>
                            </div>

                            <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                                <div v-if="!lsa_recording_data.transcription" class="text-sm" style="text-align: center;">
                                    <br />
                                    No transcription available.
                                </div>
                                <div v-else>
                                    <div>
                                        <div class="flex flex-row flex-wrap w-full">
                                            <div :class="'w-full'">
                                                <div style="font-weight: bold; padding-top: 10px; padding-bottom: 10px;">Transcription</div>

                                                <br />
                                                <div>
                                                    <b-list-group>
                                                        <b-list-group-item
                                                            v-for="(item, index) in lsa_recording_data.transcription" :key="index"
                                                    
                                                                class="d-flex align-items-center mb-4 pb-4"
                                                                style="border: none; border-bottom: solid 1px #ededed;"
                                                                v-if="index !== 'messages'"
                                                        >
                                                            <b-avatar v-if="(item.speaker == 'A' || item.speaker == 'C')"
                                                                    text="S1"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <b-avatar v-if="item.speaker == 'B'"
                                                                    text="S2"
                                                                    class="mr-3 call-info-avatar"
                                                            ></b-avatar>
                                                            <div>
                                                                <span v-if="(item.speaker == 'A' || item.speaker == 'C') && lsa_item.sources.indexOf('bland') !== -1" class="mr-auto primary-color text-bold">AI</span>
                                                                <span v-else-if="item.speaker == 'A' && lsa_item.sources.indexOf('bland') === -1" class="mr-auto primary-color text-bold">Advertiser</span>
                                                                <span v-else class="mr-auto warning-color text-bold">Caller</span>

                                                                <span class="mr-auto"> . {{ displaySpeakerTimestamp(item.start, lsa_recording_data.transcription[0].start) }} . </span>
                                                                <!-- <span v-if="item.sentiment == 'Neutral'" class="mr-auto warning-color text-bold">Neutral</span>
                                                                <span v-if="item.sentiment == 'Positive'" class="mr-auto success-color text-bold">Positive</span>
                                                                <span v-if="item.sentiment == 'Negative'" class="mr-auto danger-color text-bold">Negative</span> -->
                                                                <div class="text-sm">{{ item.text }}</div>
                                                            </div>
                                                        </b-list-group-item>
                                                    </b-list-group>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                </public-lead-details>
</div>

                <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaRecordings = false">
                    CLOSE
                </button>

                <div class="clearfix"></div>

                </div>

            </div>
        </div>

        <div v-if="showLsaMessages" @click.self="showLsaMessages = false" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
            <div class="w-full sm:w-1/3 lg:w-1/3 bg-white rounded-lg mx-6" style="max-height: 100%;">

                <div class="p-6" style="position: relative; height: calc(100% - 65px); overflow: auto;">
<public-lead-details :key="lsa_messages_lead.id" :lead="lsa_messages_lead" :report-uuid="getUUID()" @saved="onPublicQualificationSaved" @close="showLsaMessages = false">


                <div class="float-right -mb-4" style="position: relative;">
                    <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
                </div>

                <div style="clear: both;"></div>

                <div>
                    <div v-if="loading_lsa_messages" :class="'w-full mb-3'">
                        <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                    </div>
                    <div class="flex flex-row flex-wrap" v-else>
                        <div class="w-full">
                            <div id="lsa-dialog-messages-list" style="max-height: 450px; overflow: auto;">
                                <div v-if="lsa_messages_displayed.length == 0" class="text-sm" style="text-align: center;">
                                    <br />
                                    No transcription available.
                                </div>
                                <div v-else>
                                    <b-list-group>
                                        <b-list-group-item

                                            v-for="(item, index) in lsa_messages_displayed" :key="index"
                                    
                                                class="d-flex align-items-center mb-4 pb-4"
                                                style="border: none; border-bottom: solid 1px #ededed;"
                                        >
                                            <b-avatar v-if="item.participant_type == 2"
                                                    text="S1"
                                                    class="mr-3 call-info-avatar"
                                            ></b-avatar>
                                            <b-avatar v-if="item.participant_type == 3"
                                                    text="S2"
                                                    class="mr-3 call-info-avatar"
                                            ></b-avatar>
                                            <div>
                                                <span v-if="item.participant_type == 2" class="mr-auto primary-color text-bold">Advertiser</span>
                                                <span v-else class="mr-auto warning-color text-bold">Customer</span>

                                                <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item, item.event_time) }} . </span>
                                                <div class="text-sm" v-html="item.text"></div>
                                            </div>
                                        </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>

                            <div>
                                <v-text-field
                                    clearable
                                    outlined
                                    dense
                                    hide-details
                                    label="Reply"
                                    v-model="new_lsa_message"

                                    class="white border border-white"
                                ></v-text-field>
                            </div>
                        </div>
                    </div>
                </div>

                </public-lead-details>
</div>

                <div class="bg-gray-100 rounded-b-lg px-6 py-4">

                <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="showLsaMessages = false">
                    CLOSE
                </button>

                <button
                        class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4"
                        :class="{ spinner: sendingLsaMessage }"
                        @click="sendLsaReply()"
                        :disabled="!new_lsa_message"
                >
                    SEND
                </button>

                <div class="clearfix"></div>

                </div>

            </div>
        </div>


        <div class="pagehead flex items-center justify-between flex-wrap gap-4 mb-3">
          <div class="report-brand-header flex items-center gap-3 flex-wrap">
            <div v-if="agency_logo || agency_name" class="report-agency-brand flex items-center gap-2">
              <img v-if="agency_logo" :src="agency_logo" :alt="agency_name || 'Agency logo'" class="report-agency-logo">
              <span v-if="agency_name" class="report-agency-name font-bold">{{ agency_name }}</span>
            </div>

            <h2 class="text-xl font-bold text-[#16283c] m-0 report-title flex items-center gap-2">
              <span v-if="loading">Loading...</span>
              <span v-else>
                {{ company_name }} performance report<span v-if="agency_name"> by {{ agency_name }}</span>
              </span>
            </h2>
          </div>

          <!-- CUSTOM DATE RANGE FILTER (At Top of Page) -->
          <div class="relative ml-auto">
            <div class="daterange-picker-btn cursor-pointer flex items-center gap-2 px-4 py-2 rounded-lg bg-white border border-slate-300 shadow-sm hover:border-[#2fa7b8] transition-colors" @click="show_picker = !show_picker" style="height: 40px;">
              <i class="mdi mdi-calendar-blank-outline text-base text-[#2fa7b8]"></i>
              <span class="text-xs font-semibold text-slate-700 whitespace-nowrap">{{ formatDate(date_filter[0], 'MMM DD, YYYY') }} - {{ date_filter[1] ? formatDate(date_filter[1], 'MMM DD, YYYY') : '' }}</span>
            </div>

            <!-- Date Picker Popup -->
            <div v-if="show_picker" class="absolute right-0 top-12 z-50 bg-white p-4 rounded-2xl shadow-2xl border border-slate-200" style="width: 500px;">
              <div class="flex">
                <div class="pr-3 border-r border-slate-200">
                  <div class="mb-2 font-bold text-sm text-slate-800">Filter by Date</div>
                  <v-date-picker v-model="date_filter" range no-title scrollable style="border: 0px;">
                    <v-spacer></v-spacer>
                    <v-btn text color="#2fa7b8" @click="show_picker = false">Cancel</v-btn>
                    <v-btn text color="#2fa7b8" @click="filterDate();">UPDATE</v-btn>
                  </v-date-picker>
                </div>

                <div class="pl-3 text-xs space-y-1.5 flex-1 max-h-[300px] overflow-y-auto">
                  <div v-for="opt in ['This Week', 'Last Week', 'This Month', 'Last Month', 'Last 30 days', 'Last 60 days', 'Last 90 days', 'This Year', 'Last Year', 'Last 6 months', 'Last 12 months', 'Last 24 months', 'Last 36 months', 'All Time']" :key="opt">
                    <a
                      href="javascript:void(0);"
                      @click="applyDate(opt)"
                      :class="selected_date_text === opt ? 'font-extrabold text-[#2fa7b8]' : 'text-slate-600 hover:text-slate-900'"
                      class="block py-0.5"
                    >{{ opt }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr class="border-b border-gray-100 mb-3">

        <!-- <p class="sub mb-6">
        One screen: how healthy the account is, what the AI already handled for you, and the few things only you can do.
        </p> -->

        <!-- ================================================================= -->
        <!-- 2. HERO ROW: ACCOUNT HEALTH / RECOVERED / TIME SAVED / DO THIS NOW -->
        <!-- ================================================================= -->

        <!-- HERO SKELETON LOADING STATE -->
        <div v-if="loading || loadingHealth" class="grid hero mb-6">
        <div v-for="i in 4" :key="'hero-skel-' + i" class="card p-4">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        </div>

        <div v-else class="grid hero mb-6">
        <!-- HERO CARD 1: ACCOUNT HEALTH RING -->
        <div class="card flex flex-col justify-between">
            <div class="flex gap-3.5 items-center">
            <div class="ring" :style="heroRingStyle">
                <div class="inner">
                <b>{{ healthScoreValue !== null ? healthScoreValue : '--' }}<small>/100</small></b>
                <span>{{ healthScoreLabel }}</span>
                </div>
            </div>
            <div style="padding-left: 10px;">
                <div class="k uppercase">ACCOUNT HEALTH</div>
                <div class="why">
                {{ healthSummary || 'Fast answers and dispute wins are carrying your ranking. Review velocity is the next lever.' }}
                </div>
            </div>
            </div>
            <div class="bands">
            <span><span class="dot" style="background:#1d7a46"></span>90–100</span>
            <span><span class="dot" style="background:#c9a227"></span>80–89</span>
            <span><span class="dot" style="background:#d07c2e"></span>70–79</span>
            <span><span class="dot" style="background:#c0392b"></span>&lt;70</span>
            </div>
        </div>

        <!-- HERO CARD 2: RECOVERED AUTOMATICALLY -->
        <div class="card flex flex-col justify-between">
            <div>
            <div class="k uppercase">RECOVERED FOR YOU — AUTOMATICALLY</div>
            <div class="money mt-1 mb-1">${{ dashboard_data.refunds_amount || '0.00' }} back</div>
            <div class="baseline">
                + ${{ dashboard_data.refunds_amount_total || '0.00' }} pending · {{ dashboard_data.stats ? dashboard_data.stats.approved_disputes : 0 }} disputes filed by the AI — nothing for you to do
            </div>
            </div>
            <div>
            <a class="link cursor-pointer" @click="filterDisputedLeads()">
                See disputed leads →
            </a>
            </div>
        </div>

        <!-- HERO CARD 3: TIME SAVED -->
        <div class="card flex flex-col justify-between relative">
            <div>
            <div class="k uppercase">TIME SAVED</div>
            <div class="v my-1">
                {{ (dashboard_data.impact_stats && dashboard_data.impact_stats.hoursSaved) || hoursSaved || '0' }} <small>hrs</small>
            </div>

            <!-- BASELINE: TOP 3 METRICS & HOVER/CLICK DROPDOWN -->
            <div class="baseline text-xs text-slate-500 leading-snug">
                <!-- Visible Top 3 Summary -->
                <span>
                <template v-for="(metric, idx) in topImpactMetrics">
                    <strong>{{ metric.value }}</strong> {{ metric.label.toLowerCase() }}<template v-if="idx < topImpactMetrics.length - 1"> · </template>
                </template>
                </span>

                <!-- Dropdown Wrapper with Vue Mouse Events -->
                <div 
                class="inline-block relative ml-1"
                @mouseenter="showImpactBreakdown = true"
                @mouseleave="showImpactBreakdown = false"
                >
                <span class="text-indigo-600 font-bold cursor-pointer link cursor-pointer">
                    View all breakdown ▾
                </span>

                <!-- HOVER DROPDOWN PANEL -->
                <div 
                    v-if="showImpactBreakdown"
                    class="absolute left-0 bottom-full mb-2 w-72 bg-white rounded-xl shadow-xl border border-slate-200 p-4 z-50 text-slate-800 text-left"
                    style="width: 350px;"
                >
                    <div class="font-bold text-xs uppercase text-slate-400 mb-2 border-b border-slate-100 pb-1">
                    Complete Impact Breakdown
                    </div>
                    
                    <div class="space-y-1.5 text-xs">
                    <div 
                        v-for="item in impactMetricsList" 
                        :key="item.label"
                        class="flex justify-between items-center py-0.5 border-b border-slate-50 last:border-0"
                    >
                        <span class="text-slate-600">{{ item.label }}</span>
                        <span class="font-bold text-slate-900 bg-slate-100 px-2 py-0.5 rounded-md">{{ item.value }}</span>
                    </div>
                    </div>

                    <div class="mt-3 pt-2 border-t border-slate-100 text-[10px] text-slate-400">
                    Calculated live from your current period dashboard data.
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>

        <!-- HERO CARD 4: DO THIS NOW ACTION CARD -->
        <div class="card action flex flex-col justify-between">
            <div>
            <div class="k uppercase">DO THIS NOW</div>
            <div class="font-bold text-xs text-[#16283c] mt-1.5 leading-snug">
                {{ setUpNext.length > 0 ? setUpNext[0].title : 'Review unhandled leads or filter missed inquiries requiring team follow-up.' }}
            </div>
            <div class="text-[11px] text-slate-500 mt-1" v-if="setUpNext.length > 0 && setUpNext[0].description">
                {{ setUpNext[0].description }}
            </div>
            </div>
            <div>
            <router-link v-if="setUpNext.length > 0 && setUpNext[0].route" :to="setUpNext[0].route" class="cta teal cursor-pointer border-0 text-white inline-block">
                {{ setUpNext[0].action_label || 'Set up' }}
            </router-link>
            <button v-else class="cta teal cursor-pointer border-0" @click="filterMissedCalls()">
                Filter Pending Leads
            </button>
            </div>
        </div>
        </div>

        <!-- ================================================================= -->
        <!-- 3. LEADS THIS PERIOD                                             -->
        <!-- ================================================================= -->
        <h2 class="rowlabel">Leads this period</h2>

        <!-- LOADING STATE FOR LEADS THIS PERIOD -->
        <div v-if="loading || loadingMessages" class="grid cards4 mb-6">
        <div v-for="i in 4" :key="'skel-leads-' + i" class="card">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        </div>

        <div v-else class="grid cards4 mb-6">
        <!-- TOTAL LEADS -->
        <div class="card">
            <div class="k">Real Leads</div>
            <div class="v">{{ dashboard_data.total_leads || 0 }}</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.total_leads)">
            {{ comparisons.total_leads > 0 ? '↗' : '↘' }} {{ comparisons.total_leads || 0 }}%
            </span>
            <div class="baseline">vs {{ dashboard_data_prev.total_leads || 0 }} last period</div>
        <div class="converted-total" aria-live="polite">
          <span><i class="mdi mdi-check-circle-outline" aria-hidden="true"></i> Converted leads</span>
          <strong>{{ convertedStatusCount }}</strong>
        </div>
        </div>

        <!-- CALLS ANSWERED <30s -->
        <div class="card">
            <div class="k">Calls Answered &lt;30s</div>
            <div class="v">{{ answeredUnder30sRate }}%</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.lsa_30_seconds_response_rate)">
            {{ comparisons.lsa_30_seconds_response_rate > 0 ? '↗' : '↘' }} {{ comparisons.lsa_30_seconds_response_rate || 0 }}%
            </span>
            <div class="baseline">vs {{ dashboard_data_prev.stats.lsa_30_seconds_response_rate || 0 }}% last period</div>
        </div>

        <!-- MESSAGE LEADS -->
        <div class="card">
            <div class="k">Message Leads</div>
            <div class="v">{{ dashboard_data.total_message_leads || 0 }}</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.total_message_leads)">
            {{ comparisons.total_message_leads > 0 ? '↗' : '↘' }} {{ comparisons.total_message_leads || 0 }}%
            </span>
            <div class="baseline">vs {{ dashboard_data_prev.total_message_leads || 0 }} last period</div>
        </div>

        <!-- SPAM BLOCKED -->
        <div class="card">
            <div class="k">Robocalls Blocked</div>
            <div class="v">{{ dashboard_data.stats ? dashboard_data.stats.blocked_robo_calls : 0 }}</div>
            <span class="badge up">$0 charged</span>
            <div class="baseline">Kept off your line and out of your lead count</div>
        </div>
        </div>

        <!-- ================================================================= -->
        <!-- SEARCH IMPRESSIONS & VISIBILITY (LSA)                            -->
        <!-- ================================================================= -->
        <template v-if="isLsaSource">
        <h2 class="rowlabel">Search impressions &amp; visibility</h2>

        <!-- LOADING STATE FOR IMPRESSIONS -->
        <div v-if="loading || loadingMessages" class="grid cards3 mb-6">
            <div v-for="i in 3" :key="'skel-impr-' + i" class="card">
            <v-skeleton-loader type="article"></v-skeleton-loader>
            </div>
        </div>

        <div v-else class="grid cards3 mb-6">
            <!-- 1. AD IMPRESSIONS -->
            <div class="card" title="The number of times your ad appeared in search results during the selected date range.">
            <div class="k">Ad Impressions</div>
            <div class="v">{{ (dashboard_data.stats && dashboard_data.stats.total_impressions ? Number(dashboard_data.stats.total_impressions).toLocaleString() : '0') }}</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.total_impressions)">
                {{ comparisons.total_impressions > 0 ? '↗' : '↘' }} {{ comparisons.total_impressions || 0 }}%
            </span>
            <div class="baseline">vs {{ (dashboard_data_prev.stats && dashboard_data_prev.stats.total_impressions ? Number(dashboard_data_prev.stats.total_impressions).toLocaleString() : '0') }} last period</div>
            </div>

            <!-- 2. TOP IMPRESSION RATE -->
            <div class="card" title="During the selected date range, the percentage of your impressions that are shown anywhere above results that aren't paid for.">
            <div class="k">Top Impression Rate on Search</div>
            <div class="v">{{ (dashboard_data.stats && dashboard_data.stats.top_impression_rate) || '0.00' }}%</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.top_impression_rate)">
                {{ comparisons.top_impression_rate > 0 ? '↗' : '↘' }} {{ comparisons.top_impression_rate || 0 }}%
            </span>
            <div class="baseline">vs {{ (dashboard_data_prev.stats && dashboard_data_prev.stats.top_impression_rate) || '0.00' }}% last period</div>
            </div>

            <!-- 3. ABSOLUTE TOP IMPRESSION RATE -->
            <div class="card" title="During the selected date range, the percentage of your impressions that are shown as the very first ad in search results.">
            <div class="k">Absolute Top Impression Rate on Search</div>
            <div class="v">{{ (dashboard_data.stats && dashboard_data.stats.absolute_top_impression_rate) || '0.00' }}%</div>
            <span class="badge" :class="getTrendBadgeClass(comparisons.absolute_top_impression_rate)">
                {{ comparisons.absolute_top_impression_rate > 0 ? '↗' : '↘' }} {{ comparisons.absolute_top_impression_rate || 0 }}%
            </span>
            <div class="baseline">vs {{ (dashboard_data_prev.stats && dashboard_data_prev.stats.absolute_top_impression_rate) || '0.00' }}% last period</div>
            </div>
        </div>
        </template>

        <!-- ================================================================= -->
        <!-- 4. FOLLOW-UP, QUALITY & COVERAGE                                  -->
        <!-- ================================================================= -->
        <h2 class="rowlabel">Follow-up, quality &amp; coverage</h2>

        <!-- LOADING STATE FOR FOLLOW-UP, QUALITY & COVERAGE -->
        <div v-if="loading || loadingMessages" class="grid cards4 mb-6">
        <div v-for="i in 4" :key="'skel-fqc-' + i" class="card">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        </div>

        <div v-else class="grid cards4 mb-6">
        <!-- 1. FOLLOW-UPS SENT -->
        <div class="card">
            <div class="k">Follow-ups Sent</div>
            <div class="v">{{ totalFollowupsSent }}</div>
            <span class="badge info">Automated Outreach</span>
            <div class="baseline">Every lead answered with automatic follow-up nudges sent for you</div>
        </div>

        <!-- 2. LEAD QUALITY -->
        <!-- 2. LEAD QUALITY -->
        <div class="card">
            <div class="k">Lead Quality</div>
            <div class="v">{{ dashboard_data.lead_quality || '0.0' }}<small>/5</small></div>
            <span 
            class="badge" 
            :class="parseFloat(dashboard_data.lead_quality || 0) >= parseFloat(dashboard_data_prev.lead_quality || 0) ? 'up' : 'down'"
            >
            {{ parseFloat(dashboard_data.lead_quality || 0) >= parseFloat(dashboard_data_prev.lead_quality || 0) ? '↗' : '↘' }} 
            from {{ dashboard_data_prev.lead_quality || '0.0' }}
            </span>
            <div class="baseline">Scored from your submitted surveys</div>
        </div>

        <!-- 3. SURVEYS SUBMITTED -->
        <div class="card">
            <div class="k">Surveys Submitted</div>
            <div class="v">{{ surveysSubmittedCount }}</div>
            <span class="badge info">{{ surveysSubmittedCount }} of {{ dashboard_data.total_leads || 0 }} leads surveyed ({{ surveyPercentage }}%)</span>
            <div class="baseline">Every survey sharpens quality score — more surveys, truer score</div>
        </div>

        <!-- 4. SERVICE AREA DEFINED -->
        <div class="card">
            <div class="k">Service Area Defined</div>
            <template v-if="(dashboard_data.total_leads || 0) >= 50">
            <div class="v text-xl text-emerald-700 font-extrabold">Optimal</div>
            <span class="badge up">100% Configured</span>
            <div class="baseline">Service area settings active &amp; capturing leads efficiently across target radius</div>
            </template>

            <template v-else>
            <div class="v text-xl text-amber-700 font-extrabold">Partial</div>
            <span class="badge warn">Optimization Suggested</span>
            <div class="baseline">Confirm every city, county &amp; ZIP you cover so the radius tool can optimize</div>
            <router-link to="/settings/Radius" class="link cursor-pointer mt-1 inline-block">Review coverage →</router-link>
            </template>
        </div>
        </div>

        <!-- ================================================================= -->
        <!-- 5. BILLING, DISPUTES & REVIEWS                                    -->
        <!-- ================================================================= -->
        <h2 class="rowlabel">Billing &amp; reviews</h2>
        <div v-if="loading || loadingMessages" class="grid cards4 mb-6">
        <div v-for="i in 4" :key="'skel-bdr-' + i" class="card">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        </div>

        <div v-else class="grid cards4 mb-6">
        <div class="card">
            <div class="k">Charged Leads</div>
            <div class="v">{{ dashboard_data.charged_leads_total || 0 }}</div>
            <span class="badge info">Permanently Charged</span>
            <div class="baseline">vs {{ dashboard_data_prev.charged_leads_total || 0 }} last period</div>
        </div>

        <div class="card">
            <div class="k">Review Requests Sent</div>
            <div class="v">{{ dashboard_data.review_requests_sent || 0 }}</div>
            <span class="badge info">Sent via Text/Email</span>
            <div class="baseline">vs {{ dashboard_data_prev.review_requests_sent || 0 }} last period</div>
        </div>

        <div class="card">
            <div class="k">Review Links Clicked</div>
            <div class="v">{{ dashboard_data.review_links_clicked || 0 }}</div>
            <span class="badge info">Customer Engagements</span>
            <div class="baseline">Total clicks on review invitation links</div>
        </div>

        <div class="card">
            <div class="k">Reviews Gathered</div>
            <div class="v">{{ dashboard_data.review_gathered_count || 0 }}</div>
            <span class="badge up">Successfully Collected</span>
            <div class="baseline">Negative feedback count: {{ dashboard_data.negative_feedback_count || 0 }}</div>
        </div>
        </div>

        <!-- ================================================================= -->
        <!-- 6. TASK CARDS: DO THIS NOW                                        -->
        <!-- ================================================================= -->
        <h2 class="rowlabel">Do this now</h2>

        <!-- LOADING STATE FOR DO THIS NOW -->
        <div v-if="loading || loadingMessages" class="grid cards3 mb-6">
        <div v-for="i in 3" :key="'skel-dtn-' + i" class="card">
            <v-skeleton-loader type="article"></v-skeleton-loader>
        </div>
        </div>

        <div v-else class="grid cards3 mb-6">
        <!-- DYNAMIC TASK CARD FROM setUpNext OR DEFAULT FALLBACK -->
        <div class="card task" v-for="(taskItem, tIdx) in (setUpNext.length > 0 ? setUpNext : defaultTasks)" :key="'task-' + tIdx">
            <span class="tag" :class="taskItem.tagClass || 'urgent'">{{ taskItem.tagLabel || 'ACTION' }}</span>
            <div>
            <b>{{ taskItem.title }}</b>
            <p>{{ taskItem.description }}</p>

            <router-link v-if="taskItem.route" :to="taskItem.route" class="cta teal cursor-pointer mt-2 inline-block border-0 text-white">
                {{ taskItem.action_label || 'Set up' }}
            </router-link>

            <button v-else-if="taskItem.actionType === 'filter'" class="cta cursor-pointer mt-2 border-0 text-white" @click="filterMissedCalls();">
                {{ taskItem.action_label || 'Filter Missed' }}
            </button>

            <button v-else-if="taskItem.actionType === 'disputed'" class="cta teal cursor-pointer mt-2 border-0 text-white" @click="filterDisputedLeads">
                {{ taskItem.action_label || 'See disputed leads' }}
            </button>

            <div v-else-if="taskItem.actionType === 'reports'" class="flex gap-2 mt-2">
                <a class="cta bg-slate-700 cursor-pointer text-white border-0" @click="sendMonthlyReport">Send Email</a>
            </div>
            </div>
        </div>
        </div>

        <!-- ================================================================= -->
        <!-- FILTER TOOLBAR BOX (Placed above Trends & Leads)                  -->
        <!-- ================================================================= -->
        <div class="mb-3"><video-guide ids="lead-status" label="Updating lead status &amp; qualifications" /></div>
        <div class="card mb-6 filters-panel-card">
          <div class="filters-row flex items-center flex-wrap">
            <!-- SOURCE FILTER -->
            <div class="filter-item" style="position: relative;">
              <v-select
                outlined
                dense
                hide-details
                label="Source"
                class="white bg-white rounded filter-select-input"
                :items="sourceFilterOptions"
                item-text="text"
                item-value="value"
                v-model="source_filter"
                clearable
                @change="onFilterChange()"
                style="width: 200px;"
              >
                <template v-slot:selection="{ item }">
                  <div class="d-flex align-center">
                    <img v-if="item.icon" :src="item.icon" style="width: 15px; height: 15px; object-fit: contain; margin-right: 5px;" />
                    <span class="text-xs">{{ item.text }}</span>
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="d-flex align-center py-1">
                    <img v-if="item.icon" :src="item.icon" style="width: 16px; height: 16px; object-fit: contain; margin-right: 7px;" />
                    <span class="text-xs">{{ item.text }}</span>
                  </div>
                </template>
              </v-select>
            </div>

            <!-- LEAD TYPE FILTER -->
            <div class="filter-item">
              <v-select
                outlined
                dense
                hide-details
                label="Lead Type"
                class="white bg-white rounded filter-select-input"
                :items="['Show All', 'All Except Robocalls', 'High Value', 'Converted', 'In Contact', 'AI Leads', 'Missed Calls', 'Robocalls', 'Disputed']"
                v-model="filter_calls_type"
                clearable
                @change="onFilterChange()"
                style="width: 200px;"
              ></v-select>
            </div>

            <!-- LEAD QUALITY FILTER -->
            <div class="filter-item">
              <v-select
                outlined
                dense
                hide-details
                label="Quality"
                class="white bg-white rounded filter-select-input"
                :items="[5, 4, 3, 2, 1]"
                v-model="lead_quality_filter"
                clearable
                @change="onFilterChange()"
                style="width: 130px;"
              ></v-select>
            </div>

            <!-- AGENT PERFORMANCE FILTER -->
            <div class="filter-item">
              <v-select
                outlined
                dense
                hide-details
                label="Performance"
                class="white bg-white rounded filter-select-input"
                :items="[5, 4, 3, 2, 1]"
                v-model="performance_filter"
                clearable
                @change="onFilterChange()"
                style="width: 150px;"
              ></v-select>
            </div>

            <!-- DOWNLOAD CSV BUTTON -->
            <div class="filter-item ml-auto">
              <button
                class="download-csv-btn flex items-center px-4 py-2 rounded-lg font-bold text-xs bg-white border border-slate-300 text-slate-700 shadow-sm hover:bg-slate-50 hover:border-[#2fa7b8] transition-all hover:shadow cursor-pointer"
                @click="downloadCsv"
                title="Download filtered leads as CSV"
                style="height: 40px;"
              >
                <i class="mdi mdi-tray-arrow-down text-base text-[#2fa7b8] mr-2"></i>
                <span>Download CSV</span>
              </button>
            </div>
          </div>
        </div>

        <conversion-stats :stats="dashboard_data.conversions_stats" />
        <!-- ================================================================= -->
        <!-- TRENDS — DYNAMICALLY BOUND TO PIPELINE CHART DATA                 -->
        <!-- ================================================================= -->
        <div class="float-right">
        <v-switch
            v-model="expanded_chart"
            label="Expanded"
            color="success"
            inset
            dense
            hide-details
            class="ma-0 pa-0 text-xs font-bold"
        />
        </div>

        <div v-show="expanded_chart" class="float-right mr-2 -mt-2">
        <v-select
            outlined
            dense
            hide-details
            label=""
            class="white header-inputs"
            :items="['Frequency: Auto', 'Daily', 'Weekly', 'Monthly']"
            v-model="selected_frequency_chart"
            @change="loadDashboard2()"
            style="width: 175px;"
        ></v-select>
        </div>

        <h2 class="rowlabel">
        Trends — since you started with us
        </h2>

        <div style="clear: both; padding-top: 10px;"></div>

        <div class="card">
        <div v-show="!expanded_chart" class="trio">

            <!-- COLUMN 1: LEAD VOLUME (DYNAMIC) -->
            <div class="mini">
            <h4>Lead Volume <span style="color:#c6d0d9">/ week</span></h4>
            <div class="now">
                {{ calculatedWeeklyAvgLeads }}
                <span style="font-size:12px;color:#8593a3;font-weight:700">avg this month</span>
            </div>

            <svg viewBox="0 0 300 110" width="100%" height="110">
                <line x1="4" y1="90" x2="296" y2="90" stroke="#eef2f5"/>
                
                <!-- CHART 1: LEAD VOLUME (AUTO-SCALED) -->
                <polyline
                fill="none"
                stroke="#2fa7b8"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                :points="buildSparklinePoints(leadVolumeData)"
                />

                <circle
                :cx="getSparklineEndpoint(leadVolumeData).x"
                :cy="getSparklineEndpoint(leadVolumeData).y"
                r="3.5"
                fill="#2fa7b8"
                />

                <!-- Dynamic Axis Labels -->
                <text x="8" y="104" font-size="10" fill="#8593a3">{{ chartStartMonthLabel }}</text>
                <text x="272" y="104" font-size="10" fill="#8593a3">{{ chartEndMonthLabel }}</text>
            </svg>
            </div>

            <!-- COLUMN 2: ANSWERED IN <30s (DYNAMIC) -->
            <div class="mini">
            <h4>Answered in &lt;30s</h4>
            <div class="now">
                {{ answeredUnder30sRate }}%
                <span style="font-size:12px;color:#1d7a46;font-weight:700">
                ↗ from {{ previousAnsweredUnder30sRate }}%
                </span>
            </div>

            <svg viewBox="0 0 300 110" width="100%" height="110">
                <line x1="4" y1="90" x2="296" y2="90" stroke="#eef2f5"/>

                <!-- CHART 2: ANSWERED IN <30s (SCALED 0-100%) -->
                <polyline
                fill="none"
                stroke="#16283c"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                :points="buildSparklinePoints(under30sData, 0, 100)"
                />

                <!-- Dynamic Endpoint Dot -->
                <circle
                :cx="getSparklineEndpoint(under30sData, 0, 100).x"
                :cy="getSparklineEndpoint(under30sData, 0, 100).y"
                r="3.5"
                fill="#16283c"
                />

                <!-- Dynamic AI Started Annotation Line & Label -->
                <g v-if="ai_started_on">
                <line
                    :x1="getAiStartedXPosition()"
                    y1="20"
                    :x2="getAiStartedXPosition()"
                    y2="90"
                    stroke="#6c63c8"
                    stroke-dasharray="4 3"
                    stroke-width="1.5"
                />
                <text
                    :x="parseFloat(getAiStartedXPosition()) + 4"
                    y="18"
                    font-size="9.5"
                    fill="#6c63c8"
                    font-weight="700"
                >AI answering on</text>
                </g>

                <!-- Dynamic Axis Labels -->
                <text x="8" y="104" font-size="10" fill="#8593a3">{{ chartStartMonthLabel }}</text>
                <text x="272" y="104" font-size="10" fill="#8593a3">{{ chartEndMonthLabel }}</text>
            </svg>
            </div>

            <!-- COLUMN 3: LEAD QUALITY (DYNAMIC WITH DIRECTION & COLOR FIX) -->
            <div class="mini">
            <h4>Lead Quality <span style="color:#c6d0d9">/ 5</span></h4>
            <div class="now">
                {{ dashboard_data.lead_quality || '0.0' }}
                <span 
                style="font-size:12px;font-weight:700;" 
                :style="{ color: parseFloat(dashboard_data.lead_quality || 0) >= parseFloat(dashboard_data_prev.lead_quality || 0) ? '#1d7a46' : '#c0392b' }"
                >
                {{ parseFloat(dashboard_data.lead_quality || 0) >= parseFloat(dashboard_data_prev.lead_quality || 0) ? '↗' : '↘' }} 
                from {{ dashboard_data_prev.lead_quality || '0.0' }}
                </span>
            </div>

            <svg viewBox="0 0 300 110" width="100%" height="110">
                <line x1="4" y1="90" x2="296" y2="90" stroke="#eef2f5"/>

                <!-- Dynamic Polyline (0-5 Scale) -->
                <polyline
                fill="none"
                stroke="#6c63c8"
                stroke-width="2.5"
                stroke-linecap="round"
                stroke-linejoin="round"
                :points="buildSparklinePoints(leadQualityData, 0, 5)"
                />

                <!-- Dynamic Endpoint Dot -->
                <circle
                :cx="getSparklineEndpoint(leadQualityData, 0, 5).x"
                :cy="getSparklineEndpoint(leadQualityData, 0, 5).y"
                r="3.5"
                fill="#6c63c8"
                />

                <!-- Dynamic Axis Labels -->
                <text x="8" y="104" font-size="10" fill="#8593a3">{{ chartStartMonthLabel }}</text>
                <text x="272" y="104" font-size="10" fill="#8593a3">{{ chartEndMonthLabel }}</text>
            </svg>
            </div>

        </div>

        <!-- <div class="chartnote">
            Just the three numbers that matter — lead volume, answer speed, lead quality — across the whole client history. One scale per chart. Everything else lives in an Advanced view.
        </div> -->

        <div v-show="expanded_chart" class="pl-3 pt-3">
            <div class="-mt-5 -ml-4 -mb-2">
                <apexchart
                    :options="lineChartMetricsOptions"
                    :series="lineChartMetricsSeries"
                    type="line"
                    height="375"
                    ref="apexChart"
                v-if="metricsChartReady"
                />

                <div class="custom-legend centered">
                    <div
                    v-for="item in legendItems"
                    :key="item.name"
                    class="custom-legend-item"
                    :class="{
                        disabled: item.disabled,
                        dimmed: hoveredLegend && hoveredLegend !== item.name
                    }"
                    @mouseover="handleLegendHover(item)"
                    @mouseleave="handleLegendLeave"
                    @click="toggleSeries(item)"
                    >
                    <v-tooltip top color="primary">
                        <template #activator="{ on, attrs }">
                        <div class="legend-content" v-bind="attrs" v-on="on">
                            <span
                            class="legend-dot"
                            :style="{ backgroundColor: item.color }"
                            ></span>

                            <span class="legend-label">
                            {{ item.name }}
                            </span>

                            <span class="legend-value">
                            {{ item.value }}
                            </span>
                        </div>
                        </template>

                        <span>{{ item.description }}</span>
                    </v-tooltip>
                    </div>
                </div>
            </div>
        </div>
        </div>

        <!-- ID for smooth scrolling -->
        <div id="recent-leads-section"></div>

        <template>

            <div class="dashboard-box mt-6">
                <v-card class="pa-2" tile>
                    <v-skeleton-loader v-if="loading" type="article, article, article"></v-skeleton-loader>

                    <div v-if="!loading" class="p-3">
                        <div style="clear: both; padding-top: 0px;">

                            <div class="mb-3 -mt-1">
                              <div class="float-left">
                                <span style="font-size:13px;color:#555;">
                                  <span style="background:#FFF7CC;border:1px solid #E6D98A;padding:6px 6px; width: 100px; border-radius:3px;margin-right:6px;">
                                    Yellow Highlighted Leads - New leads from the last 2 weeks
                                  </span>
                                </span>
                              </div>

                              <div class="legend-items float-right pl-5">
                                <div
                                  v-for="item in legend"
                                  :key="item.value"
                                  class="legend-item"
                                >
                                  <span
                                    class="legend-badge"
                                    :class="item.class"
                                  >
                                    {{ item.value }}
                                  </span>
                                  <span class="legend-label">
                                    {{ item.label }}
                                  </span>
                                </div>
                              </div>

                              <div style="clear: both;"></div>

                                <div style="float: left; padding-top: 15px;" v-show="selected.length > 0">
                                    <button class="rounded text-blue text-xs text-bold border border-blue focus:outline-none py-2 px-4 mr-2 float-right" @click="trainAgentWithSelectedCalls();">
                                        Train Agent with selected calls
                                    </button>
                                </div>

                              <div style="clear: both;"></div>
                            </div>

                            <div v-if="filteredLeads.length === 0" class="text-center py-12 text-slate-500">
                                <i class="mdi mdi-phone-off text-4xl text-slate-300 block mb-2"></i>
                                <b class="text-slate-700 block text-sm">No Leads Found</b>
                                <span class="text-xs">No leads found for the given period. Refine your search or wait for new inquiries.</span>
                            </div>
                            <v-data-table
                                v-else
                                :headers="headers"
                                :items="filteredLeads"
                                :items-per-page="9999"
                                class="rg-datatable elevation-1"
                                mobile-breakpoint="10"
                                v-model="selected"
                                item-key="id"
                                disable-pagination
                                hide-default-footer
                                :item-class="getRowClass"
                                :show-select="((me) ? true : false)"
                                >
                                    <template v-slot:item.customer_name="{ item }">
                                        <div class="">
                                            <div style="">
                                                <i :class="leadTypeIcon(item)" class="lead-type-icon"></i>
                                                <span class="ml-2">
                                                    <span v-if="item.customer_name">{{ item.customer_name }} - </span>
                                                    <span v-if="item.job_type">{{ item.job_type }} - </span>
                                                    <span>{{ item.ai_provided_phone_number || item.customer_phone_number || item.tracking_number ||  'No phone number' }}</span>
                                                </span>
                                            </div>
                                        </div>

                                        <div v-if="item.customer_address && item.customer_address.trim()" class="customer-address">
                                            <i class="mdi mdi-map-marker-outline" aria-hidden="true"></i>
                                            <span>{{ item.customer_address }}</span>
                                        </div>

                                        <div class="lead-status-actions">
                                            <v-chip v-if="item.is_lsa_booked" small color="gray lighten-5" text-color="gray lighten-1">Booked</v-chip>
                                            <converted-badge v-if="item.is_converted == 1 || item.conversion_status === 'in_contact'" :value="item.is_converted" :status="item.conversion_status" />
                                            <span v-if="item.tag && item.tag.includes('Spam')" class="badge score-5">Blocked / Robocall</span>
                                            <span v-else-if="item.is_high_value == 1" class="badge score-1">High Value</span>
                                            <span v-else-if="isDroppedCall(item)" class="badge score-3">Dropped Call</span>
                                            <button type="button" class="qualification-row-action" @click.stop="qualificationLead = item">
                                                <i class="mdi mdi-pencil-outline" aria-hidden="true"></i> Qualification
                                            </button>
                                        </div>
                                    </template>

                                    <template v-slot:item.to="{ item }">
                                        {{ item.to || "-" }}
                                    </template>

                                    <template v-slot:item.sources="{ item }">
                                        <div class="flex items-center gap-2">

                                            <div class="flex items-center gap-2">
                                                <v-tooltip v-for="p in normalizedProviders(item)" :key="p.key" top color="primary">
                                                    <template #activator="{ on, attrs }">
                                                    <img
                                                      v-bind="attrs"
                                                      v-on="on"
                                                      :src="p.src"
                                                      :alt="p.title"
                                                      class="channel-icon"
                                                      @click="p.onClick && p.onClick(item)"
                                                      v-bind:data-lead-id="
                                                        ((item.sources || '').toLowerCase().split(',').map(s => s.trim()).includes('bland'))
                                                          ? (p.key === 'ai' ? item.id : null)
                                                          : (p.key !== 'ai' ? item.id : null)
                                                      "
                                                      :style="'cursor: initial; width: 20px; height: 20px; object-fit: contain; margin-right: 2px;'"
                                                    />
                                                    </template>
                                                    <span>{{ p.title }}</span>
                                                </v-tooltip>

                                                <v-tooltip v-if="item.sources.indexOf('bland') == -1 && item.sources.indexOf('web') == -1" top color="primary">
                                                    <template #activator="{ on, attrs }">
                                                        <i class="mdi mdi-account" v-bind="attrs" v-on="on" :style="'cursor: initial; font-size: 33px; color: #807d7d; margin-top: 4px;'"></i>
                                                    </template>
                                                    <span>This is a lead that was answered by a human</span>
                                                </v-tooltip>

                                            </div>
                                            
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_type="{ item }">
                                        <div class="flex items-center gap-2">


                                        <!-- Modality chip (Call / Message / Booking) -->
                                        <span class="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-slate-300 ml-1" style="background-color: #CCCCCC;">
                                        <i v-if="item.lead_type == 'PHONE_CALL'" class="mdi mdi-phone"></i>
                                        <i v-else-if="item.lead_type == 'MESSAGE'" class="mdi mdi-message-text-outline"></i>
                                        <i v-else-if="item.sources == 'web'" class="mdi mdi-chat"></i>
                                        <i v-else class="mdi mdi-information-outline"></i>
                                        <span v-if="item.lead_type == 'PHONE_CALL'">Call</span>
                                        <span v-else-if="item.sources == 'web'">CHAT</span>
                                        <span v-else-if="item.lead_type == 'MESSAGE'">Message</span>
                                        <span v-else-if="item.lead_type == 'BOOKING'">Booking</span>
                                        <span v-else>-</span>
                                        </span>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_creation_date="{ item }">
                                        {{ displayLeadCreationDate(item) }}

                                        <div v-show="item.lead_id || item.id">
                                            <strong>Lead ID:</strong> {{ item.lead_id || item.id }}
                                        </div>

                                        <div v-show="item.lead_source">
                                            <strong>Lead Source:</strong> {{ item.lead_source }}
                                        </div>
                                    </template>

                                    <template v-slot:item.updated_at="{ item }">
                                        {{ displayTimestamp(item, item.updated_at, true) }}
                                    </template>

                                    <template v-slot:item.responded_time="{ item }">
                                        <span v-if="item.responded_time !== NULL && item.responded_time !== -1">
                                            <span v-if="item.responded_time > 1000">
                                                {{ parseInt(item.responded_time / 60) }} minutes
                                            </span>
                                            <span v-else>
                                                {{ item.responded_time }} seconds
                                            </span>
                                        </span>
                                        <span v-else>N/A</span>
                                    </template>
                                    
                                    <template v-slot:item.geo="{ item }">
                                        <span v-if="item.geo">
                                            {{ item.geo.split(',')[0] }}
                                        </span>
                                        <span v-else>
                                            N/A
                                        </span>
                                    </template>
                                    
                                    <template v-slot:item.charge_status="{ item }">
                                        <span v-if="item.charge_status == 'CHARGED'">
                                            <span v-if="item.dispute_status == 'APPROVED'">
                                                <v-chip
                                                    small
                                                    color="green lighten-4"
                                                    text-color="green lighten-1"
                                                >
                                                    Credited
                                                </v-chip>
                                            </span>
                                            <span v-else>
                                                <v-chip
                                                    small
                                                    color="blue lighten-4"
                                                    text-color="blue lighten-1"
                                                >
                                                    Charged
                                                </v-chip>
                                            </span>
                                        </span>
                                        <span v-else>
                                            <v-chip
                                                small
                                                color="gray lighten-5"
                                                text-color="gray lighten-1"
                                            >
                                                Not Charged
                                            </v-chip>
                                        </span>


                                        <span v-if="item.credit_decision" style="margin-left: 10px;">
                                            <v-tooltip bottom content-class="intake-tooltip">
                                                <template v-slot:activator="{ on, attrs }">
                                                      <v-chip
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          :color="getSatisfactionColor(convertCreditDecisionToNumber(item.credit_decision))"
                                                          dark
                                                          class="font-weight-black"
                                                          style="height: 24px; padding: 0 7px; font-size: 12px;"
                                                      >
                                                          <span style="font-weight: 900; font-size: 12px;">
                                                              {{ convertCreditDecisionToNumber(item.credit_decision) }}
                                                          </span>
                                                      </v-chip>
                                                </template>

                                                <span class="tooltip-text">
                                                    Credit Decision: {{ item.credit_decision }}
                                                </span>
                                            </v-tooltip>
                                        </span>
                                    </template>

                                    <template v-slot:item.from="{ item }">
                                        {{ formatPhoneNumber(item.from) }}
                                    </template>

                                    <!-- NEW: Google LSA Rating column -->
                                    <template v-slot:item.ai_rating="{ item }">
                                    <div class="flex items-center gap-2">
                                        <!-- If already rated, show a green check and the final rating -->
                                        <div v-if="item.rated_at" class="flex items-center gap-2">

                                          <div v-if="item.rated_at" class="">
                                              <v-tooltip bottom content-class="intake-tooltip">
                                                  <template v-slot:activator="{ on, attrs }">
                                                      <v-chip
                                                          v-bind="attrs"
                                                          v-on="on"
                                                          :color="getSatisfactionColor(convertSatisfactionToNumber(item.satisfaction))"
                                                          dark
                                                          class="font-weight-black"
                                                          style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                      >
                                                          <span style="font-weight: 900; font-size: 16px;">
                                                              {{ convertSatisfactionToNumber(item.satisfaction) }}
                                                          </span>
                                                      </v-chip>
                                                  </template>

                                                  <span class="tooltip-text">
                                                      {{ item.additional_comments || item.summary }}
                                                  </span>
                                              </v-tooltip>

                                              <span class="text-sm pl-3">
                                                  <strong>{{ satisfactionLabelByTexts(item.satisfaction) }}</strong>
                                                  <!-- <span v-if="item.reason"> · {{ reasonLabel(item.reason) }}</span> -->
                                              </span>
                                          </div>
                                        </div>

                                        <!-- Not rated yet: show AI suggestion / actions -->
                                        <div v-else class="flex items-center gap-2">
                                            Not Rated
                                        </div>
                                    </div>
                                    </template>

                                    <template v-slot:item.intake_performance="{ item }">
                                        <div v-if="item.sources.indexOf('lsa') != -1 && item.sources.indexOf('bland') == -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.intake_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="getSatisfactionColor(item.intake_performance.rating)"
                                                            dark
                                                            class="font-weight-bold"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">{{ item.intake_performance.rating }}</span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.intake_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn v-if="isLocalHost()" small depressed @click="generateAiIntakePerformance(item)" :loading="aiLoadingInakePerformanceById[item.id]">
                                                    Generate
                                                </v-btn>
                                                <span v-else>N/A</span>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.intake_performance_notes="{ item }">
                                      <div class="p-2">{{ (item && item.intake_performance) ? item.intake_performance.explanation : "N/A" }}</div>
                                    </template>

                                    <template v-slot:item.ai_performance="{ item }">
                                        <div v-if="item.sources.indexOf('bland') != -1 || item.sources.indexOf('web') != -1" class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.ai_performance" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            small
                                                            :color="getSatisfactionColor(item.ai_performance.rating)"
                                                            dark
                                                            class="font-weight-bold"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">{{ item.ai_performance.rating }}</span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.ai_performance.explanation }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                <v-btn v-if="isLocalHost()" small depressed @click="generateAiPerformance(item)" :loading="aiLoadingAiPerformanceById[item.id]">
                                                    Generate`
                                                </v-btn>
                                                <span v-else>N/A</span>
                                            </div>
                                        </div>
                                        <div v-else>N/A</div>
                                    </template>

                                    <template v-slot:item.ai_performance_notes="{ item }">
                                        <div class="p-2">{{ (item && item.ai_performance) ? item.ai_performance.explanation : "N/A" }}</div>
                                    </template>

                                    <template v-slot:item.lead_quality="{ item }">
                                        <div class="flex items-center gap-2">
                                            <!-- If already rated, show a green check and the final rating -->
                                            <div v-if="item.rated_at" class="flex items-center gap-2">
                                                <v-tooltip bottom content-class="intake-tooltip">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            :color="getSatisfactionColor(convertSatisfactionToNumber(item.satisfaction))"
                                                            dark
                                                            class="font-weight-black"
                                                            style="height: 36px; padding: 0 14px; font-size: 16px;"
                                                        >
                                                            <span style="font-weight: 900; font-size: 16px;">
                                                                {{ convertSatisfactionToNumber(item.satisfaction) }}
                                                            </span>
                                                        </v-chip>
                                                    </template>

                                                    <span class="tooltip-text">
                                                        {{ item.additional_comments || item.summary }}
                                                    </span>
                                                </v-tooltip>
                                            </div>

                                            <!-- Not rated yet: show AI suggestion / actions -->
                                            <div v-else class="flex items-center gap-2">
                                                N/A
                                            </div>
                                        </div>
                                    </template>

                                    <template v-slot:item.lead_quality_notes="{ item }">
                                        <div class="p-2">
                                          <span v-if="item.sources.indexOf('google_ai') != -1">
                                            This call was identified as an AI generated call from Google.
                                          </span>

                                          {{ (item && (item.rated_at || item.summary)) ? (item.additional_comments || item.summary) : "N/A" }}

                                          <span v-if="item.charge_status == 'CHARGED' && item.dispute_status == 'APPROVED'">
                                            This call was sent for a refund and a credit was applied successfully.
                                          </span>
                                        </div>
                                    </template>
                                </v-data-table>
                        </div>
                    </div>
                </v-card>
            </div>
        </template>
    </div>
</template>

<script>
import { sourceFilterOptions, phoneSource } from '@/config/phoneSources';
import { formatLeadCreationDate } from '@/utils/leadTime'
/* eslint-disable no-console */
import { mapState } from 'vuex'
import ConvertedBadge from '@/components/common/ConvertedBadge.vue'
import ConversionStats from '@/components/common/ConversionStats.vue'
import PublicLeadDetails from '@/components/common/PublicLeadDetails.vue'
import $ from 'jquery';
import axios from 'axios'
import moment from 'moment'
import StatCard from  "@/views/panel/Call/StatCard.vue"

import DashboardStatsBadge from "@/views/panel/Call//DashboardStatsBadge.vue"

export default {
    components: {
        ConversionStats,
    ConvertedBadge,
    PublicLeadDetails,
        StatCard,
        DashboardStatsBadge
    },
    computed: {
    convertedStatusCount() {
      if (this.dashboard_data && this.dashboard_data.conversions_stats) return this.dashboard_data.conversions_stats.total_conversions;
      return (this.messages || []).filter(lead => lead.is_converted == 1).length;
    },
      ...mapState({
          me: state => state.me.me
      }),
      sourceFilterOptions() {
        return sourceFilterOptions;
      },

      // True when the selected source is LSA or no source filter is applied (default view)
      isLsaSource() {
        return !this.source_filter || this.source_filter === 'lsa';
      },

      // LSA-only series names — hidden when a non-LSA source is selected
      lsaOnlySeriesNames() {
        return ['Impressions', 'Absolute Top Impressions Rate', 'Clicks', 'Total Cost', 'CPL', 'Credited'];
      },

      legendItems() {
        var self = this;
        return this.lineChartMetricsSeries
          .filter(function(series) {
            // Hide LSA-only series from the legend when viewing non-LSA sources
            if (!self.isLsaSource && self.lsaOnlySeriesNames.indexOf(series.name) !== -1) {
              return false;
            }
            return true;
          })
          .map(function(series) {
            // Use original index from full seriesColors array for consistent colors
            var colorIdx = self.lineChartMetricsSeries.indexOf(series);
            return {
              name: series.name,
              color: self.seriesColors[colorIdx],
              disabled: self.activeSeriesNames.indexOf(series.name) === -1,
              description: series.description,
            };
          });
      },
      impactMetricsList() {
        const impact = (this.dashboard_data && this.dashboard_data.impact_stats) || {};
        const stats = (this.dashboard_data && this.dashboard_data.stats) || {};

        return [
            {
            label: 'Calls Answered & Notated',
            value: impact.lsaCalls || this.dashboard_data.total_calls || 0
            },
            {
            label: 'Messages Responded to',
            value: impact.lsaMessages || this.dashboard_data.total_message_leads || 0
            },
            {
            label: 'Website Chats Answered',
            value: impact.websiteChats || 0
            },
            {
            label: 'Surveys Submitted',
            value: impact.surveysSubmitted || 0
            },
            {
            label: 'Robocalls & Robocalls Screened',
            value: impact.spamCallsBlocked || stats.blocked_robo_calls || 0
            },
            {
            label: 'Booked Appointments',
            value: impact.bookedAppointments || 0
            },
            {
            label: 'Transferred Calls',
            value: impact.transferredCalls || 0
            },
            {
            label: 'Auto-Retried Messages',
            value: impact.autoRetriedMessages || 0
            }
        ];
        },

        // Shows top 3 metrics with values > 0
        topImpactMetrics() {
        return this.impactMetricsList.slice(0, 3);
        },
      filteredLeads() {
        if (!this.messages) return [];

        return this.messages.filter(lead => {
            if (this.filter_calls_type && this.filter_calls_type === 'All Except Robocalls') {
            const tagString = JSON.stringify(lead.tag || '').toLowerCase();
                if (tagString.includes('spam')) return false;

            return true;
            }

            // 1. Dropdown Filter Logic
            if (this.filter_calls_type && this.filter_calls_type !== 'Show All') {
            if (this.filter_calls_type === 'Converted') return lead.is_converted == 1;
            if (this.filter_calls_type === 'In Contact') return lead.conversion_status === 'in_contact';
            
            // 1. AI High Value Filter
            if (this.filter_calls_type === 'High Value' || this.filter_calls_type === 'High Value') {
                // Primary check: AI evaluation flag from backend
                if (lead.is_high_value === true || lead.is_high_value === 1) {
                return true;
                }

                return false;
            }

            // Disputed (PENDING or APPROVED)
            if (this.filter_calls_type === 'Disputed') {
                if (lead.satisfaction == "DISSATISFIED" || lead.satisfaction == "VERY_DISSATISFIED") return true;
                const status = lead.dispute_status ? lead.dispute_status.toUpperCase() : '';
                if (status !== 'PENDING' && status !== 'APPROVED') return false;
            }

            // Missed Calls
            if (this.filter_calls_type === 'Missed Calls') {
                const isPhoneCall = lead.lead_type === 'PHONE_CALL';
                const tagString = JSON.stringify(lead.tag || '').toLowerCase();

                if (tagString.includes('spam')) return false;
                
                // If it's NOT a phone call
                if (!isPhoneCall) {
                return false;
                }

                if (this.isDroppedCall(lead)) {
                return true;
                }

                // If it doesn't have the "missed" tag, filter it out
                if (!tagString.includes('missed')) {
                return false;
                }
            }

            // Robocalls
            if (this.filter_calls_type === 'Robocalls') {
                const tagString = JSON.stringify(lead.tag || '').toLowerCase();
                if (!tagString.includes('spam')) return false;
            }

            // Organic
            if (this.filter_calls_type === 'Organic') {
                const sources = lead.sources || [];

                // Organic is currently anything that isn't explicitly attributed
                // to LSA, AI, Web Chat, etc.
                if (
                sources.includes('lsa')
                ) {
                return false;
                }

                return true;
            }

            // AI Leads
            if (this.filter_calls_type === 'AI Leads') {
                return (lead.sources || []).includes('bland');
            }

            // Web Chat Leads
            if (this.filter_calls_type === 'Web Chat Leads') {
                return (lead.sources || []).includes('web');
            }

            // LSA Leads
            if (this.filter_calls_type === 'LSA Leads') {
                return (lead.sources || []).includes('lsa');
            }
            }

            // 2. Lead Quality Filter
            if (this.lead_quality_filter) {
                const qualityMap = {
                    5: "VERY_SATISFIED",
                    4: "SATISFIED",
                    3: "NEUTRAL",
                    2: "DISSATISFIED",
                    1: "VERY_DISSATISFIED"
                };
                if (lead.satisfaction !== qualityMap[this.lead_quality_filter]) {
                    return false;
                }
            }

            // 3. Agent Performance Filter
            if (this.performance_filter) {
                const perfVal = String(this.performance_filter);
                const aiRating = (lead.ai_performance && lead.ai_performance.rating) ? String(lead.ai_performance.rating) : null;
                const intakeRating = (lead.intake_performance && lead.intake_performance.rating) ? String(lead.intake_performance.rating) : null;
                if (aiRating !== perfVal && intakeRating !== perfVal) {
                    return false;
                }
            }

            return true;
        });
        },
      calculatedWeeklyAvgLeads() {
        const total = this.dashboard_data ? (this.dashboard_data.total_leads || 0) : 0;
        return (total / 4).toFixed(1);
      },
      headers() {
        return [
            { text: 'Customer', value: 'customer_name', width: 340, show: true },
            { text: 'Channels', value: 'sources', show: true },
            { text: 'Lead Received', value: 'lead_creation_date', width: 200, show: true },
            { text: 'Charge Status', value: 'charge_status', width: 170, show: true },
            { text: 'Google LSA Rating', value: 'ai_rating', align: 'start', sortable: false, width: 200, show: true },
            { text: 'Google LSA Rating Notes', value: 'lead_quality_notes', align: 'start', width: 200, sortable: false, show: true },
            { text: 'IP', value: 'intake_performance', align: 'start', sortable: false, show: true },
            { text: 'Intake Performance (IP) Notes', value: 'intake_performance_notes', align: 'start', sortable: false, width: 220, show: true },
            { text: 'AIP', value: 'ai_performance', align: 'start', sortable: false, show: true },
            { text: 'AI Performance (AIP) Notes', value: 'ai_performance_notes', align: 'start', sortable: false, width: 200, show: true }
        ].filter(h => h.show)
      },

    /* DYNAMIC METRIC CALCULATIONS */
    answeredUnder30sRate() {
      if (this.dashboard_data && this.dashboard_data.stats && typeof this.dashboard_data.stats.lsa_30_seconds_response_rate !== 'undefined') {
        return parseFloat(this.dashboard_data.stats.lsa_30_seconds_response_rate).toFixed(0);
      }
      return '84';
    },
    previousAnsweredUnder30sRate() {
      if (this.dashboard_data_prev && this.dashboard_data_prev.stats && typeof this.dashboard_data_prev.stats.lsa_30_seconds_response_rate !== 'undefined') {
        return parseFloat(this.dashboard_data_prev.stats.lsa_30_seconds_response_rate).toFixed(0);
      }
      return '78';
    },
    answeredUnder30sCallsCount() {
      const total = this.dashboard_data ? (this.dashboard_data.total_calls || 0) : 0;
      const rate = parseFloat(this.answeredUnder30sRate) / 100;
      return Math.round(total * rate);
    },
    totalFollowupsSent() {
      if (this.dashboard_data && typeof this.dashboard_data.review_requests_sent !== 'undefined') {
        return (this.dashboard_data.review_requests_sent || 0) + (this.stats.followUpsSent || 0);
      }
      return 64;
    },
    surveysSubmittedCount() {
      if (this.dashboard_data && this.dashboard_data.stats && typeof this.dashboard_data.stats.surveys_submitted !== 'undefined') {
        return this.dashboard_data.stats.surveys_submitted;
      }
      return this.stats.surveysSubmitted || 9;
    },
    surveyPercentage() {
      const total = this.dashboard_data.total_leads || 0;
      if (total === 0) return 0;
      return Math.round((this.surveysSubmittedCount / total) * 100);
    },

    /* HERO RING COMPUTATIONS (DERIVED DYNAMICALLY FROM FETCHHEALTH) */
    healthScoreValue() {
      if (this.healthScore !== null && typeof this.healthScore !== 'undefined') {
        return this.healthScore;
      }
      if (this.dashboard_data && typeof this.dashboard_data.health_score === 'number') {
        return this.dashboard_data.health_score;
      }
      return 87;
    },
    healthScoreLabel() {
      if (this.healthLabel) return this.healthLabel.toUpperCase();
      const s = this.healthScoreValue;
      if (s >= 90) return 'EXCELLENT';
      if (s >= 80) return 'GOOD';
      if (s >= 70) return 'FAIR';
      return 'RISK';
    },
    heroRingStyle() {
      const score = this.healthScoreValue;
      let color = '#c9a227';
      if (score >= 90) color = '#1d7a46';
      else if (score >= 80) color = '#c9a227';
      else if (score >= 70) color = '#d07c2e';
      else color = '#c0392b';
      return {
        background: `conic-gradient(${color} 0% ${score}%, #e3e9ee ${score}% 100%)`
      };
    },
    // Extract first and last month labels dynamically from lineChartMetricsOptions
      chartStartMonthLabel() {
        const cats = this.lineChartMetricsOptions.xaxis.categories || [];
        return cats.length > 0 ? cats[0] : 'Feb';
      },
      chartEndMonthLabel() {
        const cats = this.lineChartMetricsOptions.xaxis.categories || [];
        return cats.length > 0 ? cats[cats.length - 1] : 'Jul';
      },

      // Dynamic series arrays
      leadVolumeData() {
        return this.getSeriesDataByName('Lead Volume');
      },
      under30sData() {
        return this.getSeriesDataByName('Under 30s Response Rate');
      },
      leadQualityData() {
        return this.getSeriesDataByName('Lead Quality');
      }
    },
    data() {
        var self = this;
        return {
            messages: [],
            loading: true,
            loadingHealth: true,
            loadingMessages: true,
            loadError: '',

            /* /me/lsa-health DYNAMIC DATA FIELDS */
            businessName: '',
            period: '',
            healthScore: null,
            healthLabel: '',
            healthSummary: '',
            hoursSaved: '',
            whatWeDid: [],
            setUpNext: [],

            defaultTasks: [
                {
                tagClass: 'urgent',
                tagLabel: 'URGENT',
                title: 'Review Unhandled Missed Leads',
                description: 'Instantly filter leads requiring manual response or client callbacks.',
                actionType: 'filter',
                action_label: 'Filter Missed'
                },
                {
                tagClass: 'disputes',
                tagLabel: 'DISPUTES',
                title: 'Automated Disputes Log',
                description: 'AI files disputes with transcript evidence. Review approved credits.',
                actionType: 'disputed',
                action_label: 'See disputed leads'
                },
                {
                tagClass: 'reviews',
                tagLabel: 'REPORTS',
                title: 'Monthly Performance Report',
                description: 'Access live client reports in browser or trigger automated email delivery.',
                actionType: 'reports'
                }
            ],

            showBlandRecording: false,
            loading_bland_recording: true,
            bland_recording_data: {},

            showLsaRecordings: false,
            loading_lsa_recordings: true,
            lsa_recording_data: {},

            showLsaMessages: false,
            loading_lsa_messages: true,
            lsa_messages_displayed: [],
            lsa_item: null,

            cutoffDate: null,

            stats: {
                websiteChats: 0,
                lsaCalls: 0,
                lsaMessages: 0,
                followUpsSent: 0,
                surveysSubmitted: 0,
                spamCallsBlocked: 0,
                transferredCalls: 0,
                bookedAppointments: 0,
                hoursSaved: 0
            },

            selected: [],

            company_name: "",
            uuid: "",
            ai_started_on: "",
            first_lead_on: "",


            agency_name: "",
            agency_logo: "",

            survey_started_on: "",

            selectedMonth: '',
            months: [],
            high_value_filter: 'Show All',

            startDate: '', // Start date of the selected month
            endDate: '',   // End date of the selected month

            dashboard_data: [],
            dashboard_data_prev: [],
            comparisons: {},

            custom_tags: [],
            custom_statuses: [],

            aiSuggestionById: {}, // { [leadId]: { satisfaction, reason, comment, satisfactionLabel, reasonLabel } }
            aiLoadingById: {},    // { [leadId]: boolean }
            aiLoadingInakePerformanceById: {},    // { [leadId]: boolean }
            aiLoadingAiPerformanceById: {},    // { [leadId]: boolean }
            aiLoadingLeadQualityPerformanceById: {},    // { [leadId]: boolean }

            tags_items: [{
                    index: 0,
                    text: 'Not Set'
                },{
                    index: 1,
                    text: 'Existing Customer'
                },{
                    index: 2,
                    text: 'Missed Call'
                },{
                    index: 3,
                    text: 'Opportunity'
                },{
                    index: 4,
                    text: 'Meeting Scheduled'
                },{
                    index: 5,
                    text: 'Became Customer'
                },{
                    index: 'Signed',
                    text: 'Signed'
                }
                ,{
                    index: 'Booked for Consultation',
                    text: 'Booked for Consultation'
                }
                ,{
                    index: 'Declined/Not a lead',
                    text: 'Declined/Not a lead'
                }
                ,{
                    index: 'Wrong Number',
                    text: 'Wrong Number'
                }
                ,{
                    index: 'No Response',
                    text: 'No Response'
                }
                ,{
                    index: 'Existing Client',
                    text: 'Existing Client'
                }
                ,{
                    index: 'Failed Sign Up',
                    text: 'Failed Sign Up'
                }
                ,{
                    index: 'Following Up/Working on this one',
                    text: 'Following Up/Working on this one'
                }
                ,{
                    index: 'E-Doc sent not signed',
                    text: 'E-Doc sent not signed'
                }
                ,{
                    index: 'Booked to Service',
                    text: 'Booked to Service'
                }
                ,{
                    index: 'Booked for Appointment',
                    text: 'Booked for Appointment'
                }
                ,{
                    index: 'Cancelled',
                    text: 'Cancelled'
                }, {
                    index: 'Complete',
                    text: 'Complete'
                }, {
                    index: 'Incomplete',
                    text: 'Incomplete'
                }, {
                    index: 'AI Test Call',
                    text: 'AI Test Call'
                }, {
                    index: 'Duplicate Call',
                    text: 'Duplicate Call'
                }, {
                    index: 'Assisted Signing',
                    text: 'Assisted Signing'
                },
            ],

            // Static series colors — never mutated (safe from updateOptions side-effects)
            metricsChartReady: false,
      seriesColors: ["#16a34a", "rgb(255, 69, 96)", "rgb(0, 227, 150)", "rgb(0, 143, 251)", "rgb(254, 176, 25)", "#EC4899", "rgb(119, 93, 208)", "#4284C1", "rgb(56, 193, 167)", "#F97316", "#7c3aed", "#0891b2", "#15803d", "#be185d"],

            lineChartMetricsOptions: {
              colors: ["#16a34a", "rgb(255, 69, 96)", "rgb(0, 227, 150)", "rgb(0, 143, 251)", "rgb(254, 176, 25)", "#EC4899", "rgb(119, 93, 208)", "#4284C1", "rgb(56, 193, 167)", "#F97316"],
              chart: {
                  id: "line-chart",
                  toolbar: {
                      show: false
                  }
              },
              legend: {
                  show: false
                },
              xaxis: {
                  categories: [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                  ],
                  labels: {
                    style: {
                      colors: "#757B89"
                    }
                  }
              },
              yaxis: [
                {
                  seriesName: "Under 30s Response Rate",
                  show: false,
                  opposite: false,
                  min: 0,
                  max: 100,
                  labels: { show: false }
                },
                {
                  seriesName: "Lead Volume",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "Lead Quality",
                  show: false,
                  opposite: false,
                  min: 0,
                  max: 5,
                  labels: { show: false }
                },
                {
                  seriesName: "Impressions",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "Absolute Top Impressions Rate",
                  show: false,
                  opposite: false,
                  min: 0,
                  max: 100,
                  labels: { show: false }
                },
                {
                  seriesName: "Reviews",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "Clicks",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "Total Cost",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "Credited",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                },
                {
                  seriesName: "CPL",
                  show: false,
                  opposite: false,
                  min: 0,
                  labels: { show: false }
                }
              ],
              stroke: {
                  curve: "smooth",
                  width: [4, 4, 4, 4, 4, 4, 4, 4, 4]
              },
              grid: {
                borderColor: '#0000000d',
                show: true,
                xaxis: {
                  lines: { show: false }
                },
                yaxis: {
                  lines: { show: true, color: '#FF0000' }
                },
                padding: { left: 35 }
              },

              tooltip: {
                shared: true,
                intersect: false,
                custom: function(opts) {
                  var series = opts.series;
                  var dataPointIndex = opts.dataPointIndex;
                  var w = opts.w;

                  var visibleNames = self.hoveredLegend
                    ? [self.hoveredLegend]
                    : self.activeSeriesNames;

                  var formatters = [
                    function(y) { return y != null ? y.toFixed(2) + '%' : ''; },
                    function(y) { return y != null ? String(parseInt(y)) : ''; },
                    function(y) { return y != null ? parseFloat(y).toFixed(2) : ''; },
                    function(y) { return y != null ? String(parseInt(y)) : ''; },
                    function(y) { return y != null ? y.toFixed(2) + '%' : ''; },
                    function(y) { return y != null ? String(parseInt(y)) : ''; },
                    function(y) { return y != null ? String(parseInt(y)) : ''; },
                    function(y) { return y != null ? '$' + y : ''; },
                    function(y) { return y != null ? String(parseInt(y)) : ''; },
                    function(y) { return y != null ? '$' + y : ''; }
                  ];

                  var xLabel = w.globals.categoryLabels[dataPointIndex]
                    || (w.globals.labels && w.globals.labels[dataPointIndex])
                    || '';

                  var html = '<div class="apexcharts-tooltip-title" style="font-weight:600;padding:6px 10px;border-bottom:1px solid #e0e0e0">' + xLabel + '</div>';

                  for (var i = 0; i < series.length; i++) {
                    var name = w.globals.seriesNames[i];
                    if (visibleNames.indexOf(name) === -1) continue;

                    var val = series[i][dataPointIndex];
                    var fmt = (name === 'Conversion Rate' || name === 'Ad-spend ROI') ? (y => y == null ? 'Unavailable' : Number(y).toFixed(2) + '%') : name === 'Collected Revenue' ? (y => y == null ? 'Unavailable' : Number(y).toFixed(2)) : formatters[i] || function(y) { return y != null ? String(y) : ''; };
                    var color = self.seriesColors[i] || '#000';

                    html += '<div class="apexcharts-tooltip-series-group apexcharts-active" style="display:flex;align-items:center;padding:4px 10px">';
                    html += '<span class="apexcharts-tooltip-marker" style="background-color:' + color + ';width:10px;height:10px;border-radius:50%;display:inline-block;margin-right:6px"></span>';
                    html += '<span class="apexcharts-tooltip-text"><span class="apexcharts-tooltip-y-label">' + name + ': </span><span class="apexcharts-tooltip-y-value"><strong>' + fmt(val) + '</strong></span></span>';
                    html += '</div>';
                  }

                  return html;
                }
              }
          },
          lineChartMetricsSeries: [
              {
                name: "Reviews",
                data: [30, 40, 25, 50, 49, 49],
              },
          ],

          legend: [
            { value: 5, label: "Very good", class: "score-1" },
            { value: 4, label: "Good", class: "score-2" },
            { value: 3, label: "Neutral", class: "score-3" },
            { value: 2, label: "Bad", class: "score-4" },
            { value: 1, label: "Very bad", class: "score-5" },
          ],

          panel: 0,
          panel2: 0,

          hoveredLegend: null,
          // Names of series currently active (visible) — toggled by click
          activeSeriesNames: ['Under 30s Response Rate', 'Lead Volume', 'Lead Quality'],

            shouldShowChatConversation: false,
            loading_chat_conversation: false,

            new_ai_message: "",
            sendingAiMessage: false,
            ai_messages_lead: null,

            savingAiFeedback: false,

            qualificationLead: null,
            lead_id: null, // set this when opening dialog

            uploading: false,

            auto_survey_services: "",
            auto_survey_non_services: "",

            expanded_chart: false,

            show_picker: false,
            date_filter: [
                moment().subtract(30, 'days').format('YYYY-MM-DD'),
                moment().format('YYYY-MM-DD')
            ],

            all_time: 0,
            selected_date_text: "Last 30 days",
            filter_only_lsa: 0,

            showDisputedOnly: false,

            showExtraFilters: false,

            showImpactBreakdown: false, // Controls hover/click dropdown state

            filter_calls_type: 'All Except Robocalls',
            lead_quality_filter: null,
            performance_filter: null,
            source_filter: null,

            selected_frequency_chart: "Monthly",

            timezone: "America/New_York",
            
        }
    },

    methods: {
        onPublicQualificationSaved(data) {
            const leads = [this.qualificationLead, this.ai_messages_lead, this.lsa_item, this.lsa_messages_lead, ...(this.messages || [])];
            leads.filter(lead => lead && lead.id == data.lead_id).forEach(lead => {
                ['is_high_value', 'is_converted', 'conversion_status'].forEach(key => {
                    if (Object.prototype.hasOwnProperty.call(data, key)) this.$set(lead, key, key === 'is_high_value' ? (data[key] ? 1 : 0) : data[key]);
                });
            });
            this.loadDashboard().catch(error => console.error('Could not refresh report totals:', error));
        },
        getSeriesMinMax(series) {
          if (!series) return { min: 0, max: 100 };

          const name = series.name;
          if (name === 'Under 30s Response Rate' || name === 'Absolute Top Impressions Rate') {
            return { min: 0, max: 100 };
          }
          if (name === 'Lead Quality') {
            return { min: 0, max: 5 };
          }

          // Define which series names represent money and need to be divided by 1 million
          // Add your actual financial series names to this array:
          const financialSeriesNames = ['Cost']; 
          const shouldDivideByMillion = financialSeriesNames.includes(name);

          const values = (series.data || [])
            .filter(value => value !== null && value !== undefined)
            .map(value => {
              // Remove commas from string numbers (e.g., '64,004,166.67' -> '64004166.67')
              const cleanVal = typeof value === 'string' ? value.replace(/,/g, '') : value;
              const num = Number(cleanVal);
              
              if (isNaN(num)) return null;

              // Only divide by 1 million if it's a financial series
              return shouldDivideByMillion ? num / 1000000 : num;
            })
            .filter(value => value !== null && !isNaN(value));

          if (!values.length) {
            return {
              min: 0,
              max: 1
            };
          }

          const maxVal = Math.max(...values);
          return {
            min: 0,
            max: maxVal > 0 ? maxVal : 1
          };
        },
        getYAxisFormatter(name) {
            switch (name) {
                case 'Conversion Rate':
                case 'Ad-spend ROI':
                case 'Under 30s Response Rate':
                    return value => value != null && !isNaN(value) ? `${Number(value).toFixed(2)}%` : '';

                case 'Total Cost':
                case 'CPL':
                    return value => value != null && !isNaN(value) ? `$${Number(value).toFixed(2)}` : '';

                case 'Collected Revenue':
                case 'Lead Quality':
                    return value => value != null && !isNaN(value) ? Number(value).toFixed(2) : '';

                case 'Conversions':
                case 'Lead Volume':
                case 'Impressions':
                case 'Reviews':
                case 'Clicks':
                case 'Credited':
                    return value => value != null && !isNaN(value) ? Math.round(Number(value)) : '';

                case 'Absolute Top Impressions Rate':
                    return value => value != null && !isNaN(value) ? `${Number(value).toFixed(2)}%` : '';

                default:
                    return value => value != null ? value : '';
            }
        },
            isDroppedCall(lead) {
              if (lead.lead_type != "PHONE_CALL")
                return false;

              if (lead.tag.includes('spam'))
                return false;

              if (lead.is_high_value == 1)
                return false;

              if (lead.lsa_transcription) {
                let tr = JSON.parse(lead.lsa_transcription);
                if (tr.length > 4)
                  return false;
              }

              if (lead.bland_transcription) {
                let tr = JSON.parse(lead.bland_transcription);
                if (tr.length > 4)
                  return false;
              }

              return true;
            },
            logPublicView() {
                axios.post(`${process.env.VUE_APP_API_ENDPOINT}/public-report/log-view`, {
                }, {
                    headers: {
                        Authorization: `Bearer ${this.getUUID()}`,
                        'RG-Auth-Loc-Uu': this.getUUID()
                    }
                });
            },
            
            async onFilterChange() {
                await this.getMessages(true);
            },

            // Method called when selecting an item in the dropdown
            filterCallsType(val) {
                this.filter_calls_type = val || 'All Except Robocalls';
                this.onFilterChange();
            },

            // Button 1: "Filter Missed" & "Filter Pending Leads"
            filterMissedCalls() {
                this.filter_calls_type = 'Missed Calls';
                this.onFilterChange();
                this.scrollToRecentLeads();
            },

            // Button 2: "See Disputed Leads"
            filterDisputedLeads() {
                this.filter_calls_type = 'Disputed';
                this.onFilterChange();
                this.scrollToRecentLeads();
            },

            scrollToRecentLeads() {
                this.$nextTick(() => {
                    const section = document.querySelector('.rg-lead-list') || document.querySelector('#recent-leads-section');
                    if (section) {
                        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                });
            },
            async saveAiFeedback(item) {
                this.savingAiFeedback = true;
                await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-feedback`, {
                    lead_id: item.id,
                    ai_feedback: item.ai_feedback,
                    ai_feedback_urgent: item.ai_feedback_urgent
                }, {
                    headers: { 'Authorization': 'Bearer ' + this.$store.state.auth.jwt }
                });
                this.savingAiFeedback = false;
                if (this.ai_messages_lead) this.ai_messages_lead.show_ai_feedback = false;
            },
            filterDate() {
                if (!this.date_filter[1]) return;
                this.show_picker = false;
                this.selected_date_text = '';
                this.getMessages();
            },
            applyDate(selected_date) {
                this.all_time = 0;
                this.selected_date_text = selected_date;
                switch (selected_date) {
                    case 'This Week':
                    this.date_filter[0] = moment().startOf('week').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().endOf('week').format('YYYY-MM-DD');
                    break;
                    case 'Last Week':
                    this.date_filter[0] = moment().startOf('week').subtract(7, 'days').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().endOf('week').subtract(7, 'days').format('YYYY-MM-DD');
                    break;
                    case 'This Month':
                    this.date_filter[0] = moment().startOf('month').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().endOf('month').format('YYYY-MM-DD');
                    break;
                    case 'Last Month':
                    this.date_filter[0] = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
                    break;
                    case 'Last 60 days':
                    this.date_filter[0] = moment().subtract(60, 'days').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().format('YYYY-MM-DD');
                    break;
                    case 'Last 90 days':
                    this.date_filter[0] = moment().subtract(90, 'days').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().format('YYYY-MM-DD');
                    break;
                    case 'This Year':
                    this.date_filter[0] = moment().startOf('year').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().endOf('year').format('YYYY-MM-DD');
                    break;
                    case 'Last Year':
                    this.date_filter[0] = moment().startOf('year').subtract(1, 'year').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().endOf('year').subtract(1, 'year').format('YYYY-MM-DD');
                    break;
                    case 'All Time':
                    this.date_filter[0] = moment().startOf('year').subtract(10, 'years').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().format('YYYY-MM-DD');
                    this.all_time = 1;
                    break;
                    default:
                    this.date_filter[0] = moment().subtract(30, 'days').format('YYYY-MM-DD');
                    this.date_filter[1] = moment().format('YYYY-MM-DD');
                }
                this.show_picker = false;
                this.getMessages();
            },
            
            initFromUrl() {
                const query = new URLSearchParams(window.location.search);
                if (query.get('lead_type') === 'High Value') this.filter_calls_type = 'High Value';
                const start = query.get('start_date');
                const end = query.get('end_date');
                if (moment(start, 'YYYY-MM-DD', true).isValid() && moment(end, 'YYYY-MM-DD', true).isValid() && start <= end) {
                  this.date_filter = [start, end];
                }
                const hash = window.location.hash.slice(1); // "month=2026-02&leadId=319876"
                const params = new URLSearchParams(hash);

                const month = params.get("month");   // "2026-02"
                const leadId = params.get("leadId"); // "319876"

                console.log('month', month);
                console.log('leadId', leadId);

                if (month) {
                  this.selectedMonth = month;
                }

                if (leadId) {
                  this.$nextTick(() => {
                    this.openLeadWhenReady(leadId);
                  });
                }
              },

              openLeadWhenReady(leadId, {
                intervalMs = 250,
                timeoutMs = 15000,
                scroll = true
              } = {}) {
                const start = Date.now();

                const tryClick = () => {
                  const el = document.querySelector(`[data-lead-id="${leadId}"]`);

                  if (el) {
                    if (scroll) el.scrollIntoView({ behavior: "smooth", block: "center" });
                    el.click();
                    return; // done
                  }

                  if (Date.now() - start >= timeoutMs) {
                    console.warn(`Lead ${leadId} not found after ${timeoutMs}ms`);
                    return; // give up
                  }

                  setTimeout(tryClick, intervalMs);
                };

                tryClick();
              },

            async switchAiResponseEnabled(lead) {
                console.log('lead', lead);

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
                    lead_id: lead.id,
                    ai_enabled: lead.ai_enabled
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                console.log('response', response);
            },

            async sendLsaReply() {
                this.sendingLsaMessage = true;
                
                let self = this;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                    lead_id: self.lsa_messages_lead.id,
                    message: self.new_lsa_message
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.lsa_messages_displayed.push({
                    event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                    participant_type: 2,
                    text: self.new_lsa_message
                });

                this.sendingLsaMessage = false;
                this.new_lsa_message = "";

                setTimeout(function() {
                    var objDiv = document.getElementById("lsa-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            async sendAiReply() {
                this.sendingAiMessage = true;
                
                let self = this;

                console.log('this.bland_recording_data', this.bland_recording_data);

                if (this.bland_recording_data.sources && this.bland_recording_data.sources.indexOf('lsa') != -1) {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-lsa-message`, {
                        lead_id: this.bland_recording_data.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }
                else {
                    let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
                        lead_id: self.ai_messages_lead.id,
                        message: self.new_ai_message,
                        respond_as: this.respond_as || (this.company_name)
                    }, {
                        headers: {
                            'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                        }
                    });
                }

                try {
                    this.bland_recording_data.transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        custom_name: this.respond_as || (this.company_name)
                    });
                }
                catch (e) {

                }

                try {
                    this.bland_transcription.messages.push({
                        created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
                        is_bland: 1,
                        // is_person: 1,
                        message: self.new_ai_message,
                        content: self.new_ai_message,
                        custom_name: this.respond_as || (this.me.company_name)
                    });
                }
                catch (e) {

                }

                this.sendingAiMessage = false;
                this.new_ai_message = "";

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("ai-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }

                try {
                    setTimeout(function() {
                        var objDiv = document.getElementById("chat-dialog-messages-list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }, 10);
                }
                catch (e) {
                }
            },

            async showChatConversation(item) {
                let self = this;

                this.shouldShowChatConversation = true;
                this.loading_chat_conversation = true;
                this.ai_messages_lead = item;

                if (this.ai_messages_lead.ai_enabled == 1)
                    this.ai_messages_lead.ai_enabled = true;
                else
                    this.ai_messages_lead.ai_enabled = false;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-chat-conversation`, {
                    lead_id: item.id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                this.bland_transcription = response.data.transcription;
                this.loading_chat_conversation = false;

                setTimeout(function() {
                    var objDiv = document.getElementById("chat-dialog-messages-list");
                    objDiv.scrollTop = objDiv.scrollHeight;
                }, 10);
            },

            // Controls which series are visible using stroke.width and colors arrays.
            _applyVisibility(hoveredName) {
              if (!this.$refs.apexChart) return;
              var series = this.lineChartMetricsSeries;
              var active = this.activeSeriesNames;
              var baseColors = this.seriesColors;

              var strokeWidths = series.map(function(s) {
                if (hoveredName !== null) {
                  return s.name === hoveredName ? 4 : 0;
                }
                return active.indexOf(s.name) !== -1 ? 4 : 0;
              });

              var colors = series.map(function(s, idx) {
                var visible = hoveredName !== null
                  ? s.name === hoveredName
                  : active.indexOf(s.name) !== -1;
                return visible ? (baseColors[idx] || '#000000') : 'transparent';
              });

              this.$refs.apexChart.updateOptions({
                stroke: { curve: 'smooth', width: strokeWidths },
                markers: { size: 0 },
                colors: colors
              }, false, false);
            },

            handleLegendHover(item) {
              if (!this.$refs.apexChart) return;
              this.hoveredLegend = item.name;

              this._applyVisibility(item.name);

              var hoveredSeries = null;
              for (var i = 0; i < this.lineChartMetricsSeries.length; i++) {
                if (this.lineChartMetricsSeries[i].name === item.name) {
                  hoveredSeries = this.lineChartMetricsSeries[i];
                  break;
                }
              }
              if (!hoveredSeries) return;

              var minMax = this.getSeriesMinMax(hoveredSeries);
              var min = minMax.min;
              var max = minMax.max;
              var self = this;
              var yaxis = this.lineChartMetricsOptions.yaxis.map(function(axis) {
                var isTarget = axis.seriesName === item.name;
                return Object.assign({}, axis, {
                  show: isTarget,
                  labels: Object.assign({}, axis.labels || {}, {
                    show: isTarget,
                    formatter: isTarget ? self.getYAxisFormatter(item.name) : undefined
                  }),
                  min: isTarget ? min : axis.min,
                  max: isTarget ? max : axis.max,
                  tickAmount: isTarget ? 1 : undefined
                });
              });
              this.$refs.apexChart.updateOptions({ yaxis: yaxis }, false, false);
            },

            handleLegendLeave() {
              if (!this.$refs.apexChart) return;
              this.hoveredLegend = null;

              this._applyVisibility(null);

              // Hide all Y-axis labels and release layout space while preserving scale
              var yaxis = this.lineChartMetricsOptions.yaxis.map(function(axis) {
                return Object.assign({}, axis, {
                  show: false,
                  tickAmount: undefined,
                  labels: Object.assign({}, axis.labels || {}, { show: false })
                });
              });
              this.$refs.apexChart.updateOptions({ yaxis: yaxis }, false, false);
            },

            toggleSeries(item) {
              if (!this.$refs.apexChart) return;

              var idx = this.activeSeriesNames.indexOf(item.name);
              if (idx !== -1) {
                this.activeSeriesNames.splice(idx, 1);
              } else {
                this.activeSeriesNames.push(item.name);
              }

              this.hoveredLegend = null;
              this._applyVisibility(null);
            },

            async generateAiIntakePerformance(item) {
                this.$set(this.aiLoadingInakePerformanceById, item.id, true);
                try {
                let transcript = item.lsa_transcription;

                if (!transcript)
                    transcript = item.lsa_messages;

                const intake_performance = await this.callOpenAIForIntakePerformance(item.id, transcript);

                console.log('intake_performance', intake_performance);

                item.intake_performance = intake_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingInakePerformanceById, item.id, false);
                }
            },

            async generateAiPerformance(item) {
                this.$set(this.aiLoadingAiPerformanceById, item.id, true);
                try {
                let transcript = item.bland_transcription;

                const ai_performance = await this.callOpenAIForAiPerformance(item.id, transcript);

                console.log('ai_performance', ai_performance);

                item.ai_performance = ai_performance;

                } catch (e) {
                    console.error('AI suggestion failed:', e);
                } finally {
                    this.$set(this.aiLoadingAiPerformanceById, item.id, false);
                }
            },

            async callOpenAIForIntakePerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-intake-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            async callOpenAIForAiPerformance(lead_id, transcriptPlainText) {
                const user = transcriptPlainText;

                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/analysys/analyze-ai-performance`, {
                    user: user,
                    lead_id: lead_id
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                });

                return response.data;
            },

            isLocalHost() {
                return this.getHost().indexOf('localhost') != -1 || this.getHost().indexOf('automatic-robot') != -1;
            },

            getMonthlyReport() {
                window.open('/leads-public-survey/' + this.me.uuid + "?cutoff_date=" + moment().subtract(2, 'weeks').format('YYYY-MM-DD'));
            },

            async sendMonthlyReport(item, qualify_status) {
                let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/send-monthly-survey-report`, {
                    now: 2
                }, {
                    headers: {
                        'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                    }
                })

                this.$swal({
                    title: "Email sent!",
                    text: "The report has been successfully sent to the customer!",
                    showCancelButton: false,
                });
            },

            downloadCsv() {
                this.exporting = true;

                let self = this;

                let csv = 'Customer, Phone, Address, Timestamp, Lead Type, Sources, Charge Status, Survey Score, Survey Notes, Intake Score, Intake Notes, AI Score, AI Rating\n';
                const leadsToExport = (this.filteredLeads && this.filteredLeads.length > 0) ? this.filteredLeads : this.messages;
                leadsToExport.forEach((row) => {

                    let customer = row.customer_name || '';
                    if (!customer && row.job_type) {
                        customer = row.job_type;
                    }
                    const phone = row.ai_provided_phone_number || row.customer_phone_number || row.tracking_number || '';
                    const address = (row.customer_address || row.address || '').replace(/"/g, '""');

                    let tags = [];

                    for (var i in row.tag) {
                        for (var j in this.tags_items) {
                            if (this.tags_items[j].index == row.tag[i]) {
                                tags.push(this.tags_items[j].text);
                            }
                        }
                    }

                    let lead_status = "Not Set";

                    switch (row.qualify_status) {
                        case 1:
                            lead_status = 'Qualified';
                        break;
                        case -1:
                            lead_status = 'Unqualified';
                        break;
                        case 2:
                            lead_status = 'Spam';
                        break;
                    }

                    if (row.qualify_status != 0 && row.qualify_status != 1 && row.qualify_status != 2 && row.qualify_status != -1) {
                        lead_status = row.qualify_status;
                    }

                    let survey_score = "N/A";
                    let survey_notes = "N/A";
                    let intake_score = "N/A";
                    let intake_notes = "N/A";
                    let ai_score = "N/A";
                    let ai_notes = "N/A";

                    if (row.rated_at) {
                        survey_score = self.convertSatisfactionToNumber(row.satisfaction);

                        survey_notes = row.additional_comments || row.summary;
                    }

                    if (row.intake_performance) {
                        intake_score = row.intake_performance.rating;
                        intake_notes = row.intake_performance.explanation;
                    }

                    if (row.ai_performance) {
                        ai_score = row.ai_performance.rating;
                        ai_notes = row.ai_performance.explanation;
                    }

                    let csv_data = [
                        '"' + customer.replace(/"/g, '""') + '"',
                        '"' + phone + '"',
                        '"' + address + '"',
                        '"' + self.displayLeadCreationDate(row) + '"',
                        '"' + (row.lead_type || '') + '"',
                        '"' + ((row.sources || '').replace('bland', 'AI')) + '"',
                        // '"' + tags.join(",") + '"',
                        '"' + (row.charge_status || '') + '"',
                        '"' + survey_score + '"',
                        '"' + (survey_notes || '').replace(/"/g, '""') + '"',
                        '"' + intake_score + '"',
                        '"' + (intake_notes || '').replace(/"/g, '""') + '"',
                        '"' + ai_score + '"',
                        '"' + (ai_notes || '').replace(/"/g, '""') + '"'
                    ]

                    csv += csv_data.join(',');
                    csv += "\n";
                });

                csv = csv.replace(/null/g, "");
            
                const anchor = document.createElement('a');
                anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
                anchor.target = '_blank';
                anchor.download = 'diyai-leads.csv';
                anchor.click();

                this.exporting = false;
            },

          async markBooked(item) {
                item.marking_booked = true;

                item.is_lsa_booked = true;

              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/inbox/mark-lead-booked`, {
                  id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              this.getMessages(true);
          },

          displaySpeakerTimestamp(milliseconds, firstItemMilliseconds) {
              //Get hours from milliseconds
              var hours = milliseconds / (1000*60*60);

              //if (firstItemMilliseconds < 1000)
                //hours = milliseconds / (100*60*60);

              var absoluteHours = Math.floor(hours);
              var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

              //Get remainder from hours and convert to minutes
              var minutes = (hours - absoluteHours) * 60;
              var absoluteMinutes = Math.floor(minutes);
              var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

              //Get remainder from minutes and convert to seconds
              var seconds = (minutes - absoluteMinutes) * 60;
              var absoluteSeconds = Math.floor(seconds);
              var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;

              return h + ':' + m + ':' + s;
        },

        async showBlandRecordingFunction(item) {

          this.ai_messages_lead = item;
          this.ai_messages_lead.show_ai_feedback = false;

          if (this.ai_messages_lead.ai_enabled == 1)
              this.ai_messages_lead.ai_enabled = true;
          else
              this.ai_messages_lead.ai_enabled = false;

          let self = this;

          this.showBlandRecording = true;
          this.loading_bland_recording = true;
          
          this.bland_recording_data.recording_url = item.bland_recording_url;
          this.bland_recording_data.sources = item.sources;
          this.bland_recording_data.lead_type = item.lead_type;
          this.bland_recording_data.id = item.id;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.bland_recording_data.transcription = response.data.transcription;

          let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
          original_ai_messages = original_ai_messages.messages;

          console.log('original_ai_messages', original_ai_messages);

          if (item.lead_type == "MESSAGE" && item.sources.indexOf('lsa') != -1) {
              let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                  lead_id: item.id
              }, {
                  headers: {
                      'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                  }
              });

              for (var i in response.data.lsa_messages) {
                  response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                  response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                  response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                  // response.data.lsa_messages[i].is_person = 0;
                  response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                  response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                  for (var j in original_ai_messages) {
                      console.log('compare 1:', response.data.lsa_messages[i].message);
                      console.log('compare 2:', original_ai_messages[j].body);
                      if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                          console.log("FOUD AI MESSAGE");
                          console.log(response.data.lsa_messages[i].message);
                          response.data.lsa_messages[i].is_person = 0;
                          break;
                      }
                  }

                  if (response.data.lsa_messages[i].text.indexOf('did you get my last message') != -1) {
                      response.data.lsa_messages[i].is_person = 0;
                  }
              }

              this.bland_recording_data.transcription.messages = response.data.lsa_messages;
          }

          this.bland_recording_data.summary = response.data.summary;
          this.bland_recording_data.customer_name = item.customer_name;
          this.bland_recording_data.customer_email = item.customer_email;
          this.bland_recording_data.ai_provided_phone_number = item.ai_provided_phone_number;
          this.bland_recording_data.job_type = item.job_type;
          this.bland_recording_data.call_ended_by = item.call_ended_by;
          this.bland_recording_data.sentiment = response.data.sentiment;
          this.bland_recording_data.topics_discussed = response.data.topics_discussed;
          this.bland_recording_data.issues_raised = response.data.issues_raised;
          this.bland_recording_data.analysis = response.data.analysis;
          this.bland_recording_data.variables = response.data.variables;
          this.loading_bland_recording = false;

          if (response.data.recording_url)
              this.bland_recording_data.recording_url = response.data.recording_url;

          setTimeout(function() {
              if (self.bland_recording_data.recording_url) {
                  document.querySelector('#bl-audio-el-here').innerHTML = '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayLeadCreationDate(item) + '</div><audio onwindowresize="" controls="true" class="u-hide" src="' + self.bland_recording_data.recording_url + '" style="width: 100%"></audio>';
              }
          }, 500);

          setTimeout(function() {
              var objDiv = document.getElementById("ai-dialog-messages-list");
              objDiv.scrollTop = objDiv.scrollHeight;
          }, 10);
      },

      async showLsaCallRecordings(item) {
          
          let self = this;

          console.log('this.lsa_item', this.lsa_item);

          this.showLsaRecordings = true;
          this.loading_lsa_recording = true;
          this.lsa_item = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-recordings`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_recordings = false;

          this.lsa_recording_data = JSON.parse(JSON.stringify(response.data));

          console.log('this.lsa_recording_data', this.lsa_recording_data);

          if (response.data.recordings.length > 0) {
              let recordings_html = '';

              for (var i in response.data.recordings) {
                  recordings_html += '<div class="mr-auto text-xs text-gray-600 pb-2">Recording Timestamp: ' + self.displayLeadCreationDate(item) + '</div><div style="margin-bottom: 15px;"><audio onwindowresize="" controls="true" class="u-hide" src="' + response.data.recordings[i] + '" style="width: 100%"></audio></div>';
              }

              setTimeout(function() {
                  document.querySelector('#lsa-audio-el-here').innerHTML = recordings_html;
              }, 500);
          }
          else {
              document.querySelector('#lsa-audio-el-here').innerHTML = 'No recordings found.';
          }
      },

      async showLsaMessagesFunction(item) {
      
          // console.log('item.sources', item.sources)
          // console.log('itemplmmmm', item);

          // console.log(1);

          // console.log("item.sources.indexOf('bland')", item.sources.indexOf('bland'))

          if (item.sources.indexOf('bland') != -1) {
              console.log(2);
              this.showBlandRecordingFunction(item);
              return;
          }

          console.log(3);

          
          let self = this;

          this.showLsaMessages = true;
          this.loading_lsa_messages = true;
          this.lsa_messages_lead = item;

          let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
              lead_id: item.id
          }, {
              headers: {
                  'Authorization': 'Bearer ' + this.$store.state.auth.jwt
              }
          });

          this.loading_lsa_messages = false;

          this.lsa_messages_displayed = response.data.lsa_messages;
          this.loading_lsa_messages = false;
      },

        readCutoffFromQuery() {
          const params = new URLSearchParams(window.location.search);
          const cutoff = params.get("cutoff_date");

          if (cutoff && moment(cutoff, "YYYY-MM-DD", true).isValid()) {
            this.cutoffDate = moment(cutoff, "YYYY-MM-DD").startOf("day");
          } else {
            this.cutoffDate = moment().subtract(2, 'weeks').format('YYYY-MM-DD');
          }
        },

        isNewLead(item) {
          if (!this.cutoffDate || !item.lead_creation_date) return false;

          const leadDate = moment(item.lead_creation_date, "YYYY-MM-DD HH:mm:ss", true);
          if (!leadDate.isValid()) return false;

          return leadDate.isAfter(this.cutoffDate);
        },

        getRowClass(item) {
          return this.isNewLead(item) ? "new-lead-highlight" : "";
        },

        getHost() {
        return window.location.host;
        },

        isOnlyAi() {
            return !this.isAccelerate();
        },

        isAccelerate() {
            //  || this.getHost() == 'zany-space-palm-tree-q9vjg4xr39j97-8080.app.github.dev'
            return this.getHost() == 'lsa.accelerateyourmarketing.com';
        },

        getCustomTagColor(tag) {
            for (var i in this.custom_tags) {
                if (this.custom_tags[i].tag == tag)
                    return this.custom_tags[i].color;
            }

            return "";  
        },

        getCustomStatusColor(status) {
            for (var i in this.custom_statuses) {
                if (this.custom_statuses[i].status == status)
                    return this.custom_statuses[i].color;
            }

            return "";  
        },

        formatDate: function(date, format = "MM/DD/YYYY") {
            return moment(String(date)).format(format)
        },

        displayLeadCreationDate(lead) {
            if (!String(lead.sources || '').split(',').some(source => source.trim() === 'lsa')) {
              return this.displayTimestamp(lead, lead.lead_creation_date);
            }
            return formatLeadCreationDate(lead, this.timezone);
        },
        displayTimestamp(item, date, force_utc) {
            if (!date) return '';

            let userTimezone = this.timezone;

            if (item.sources !== 'bland' && !force_utc) {
                // Already in local Chicago time from LSA API
                return moment.tz(date, userTimezone).format('ddd M/D/YYYY h:mm:ss A');
            }

            // Local DB entry (stored in UTC) -> convert to target timezone
            return moment.utc(date).tz(userTimezone).format('ddd M/D/YYYY h:mm:ss A');
        },

        displayDuration(seconds) {
            return date;
        },

        trainAgentWithSelectedCalls() {
            this.selected = [];

            this.$swal({
                title: "Saved",
                text: "Selected calls will be used as knowledge for AI Agent, based on each call's quality!",
                showCancelButton: false,
            });
        },
        
        satisfactionLabel(value) {
            const map = {
                1: 'Very Satisfied',
                2: 'Satisfied',
                3: 'Neutral',
                4: 'Unsatisfied',
                5: 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        satisfactionLabelByTexts(value) {
            const map = {
                "VERY_SATISFIED": 'Very Satisfied',
                "SATISFIED": 'Satisfied',
                "NEUTRAL": 'Neutral',
                "DISSATISFIED": 'Unsatisfied',
                "VERY_DISSATISFIED": 'Very Unsatisfied'
            };
            return map[value] || 'Not Set';
        },

        convertSatisfactionToNumber(value) {
            const map = {
                "VERY_SATISFIED": 5,
                "SATISFIED": 4,
                "NEUTRAL": 3,
                "DISSATISFIED": 2,
                "VERY_DISSATISFIED": 1
            };
            return map[value] || 3;
        },

        convertCreditDecisionToNumber(value) {
            const map = {
                'Not specified': 3,
                'Unknown in this API version': 3,
                'Credit issued, cap not reached': 5,
                'Credit issued, cap reached': 4,
                'No credit, cap reached': 2,
                'No credit, not eligible': 1

            };
            return map[value] || 3;
        },

        getSatisfactionColor(value) {
            const map = {
                "1": "#ef4444",
                "2": "#fb923c",
                "3": "#facc15",
                "4": "#22c55e",
                "5": "#16a34a"
            };

            return map[value];
        },

        reasonLabel(reason) {
            // If you store reasons as strings already, just return them.
            // If your backend uses codes, map those codes to labels here.
            return reason || '—';
        },

        // Map an array of numerical values dynamically to SVG coordinate points
        buildSparklinePoints(dataArray, minVal = null, maxVal = null) {
        // Ensure array exists and convert any string numbers to floats
        if (!dataArray || !Array.isArray(dataArray) || dataArray.length === 0) {
            return '10,75 285,75';
        }

        const cleanNums = dataArray.map(v => parseFloat(v) || 0);

        const svgWidth = 275;  // 10 to 285 X-range
        const startX = 10;
        const minY = 20;       // Top padding (Y-min)
        const maxY = 75;       // Bottom line baseline Y

        // Auto-scale relative to data if min/max aren't explicitly passed
        let actualMin = minVal !== null ? minVal : Math.min(...cleanNums);
        let actualMax = maxVal !== null ? maxVal : Math.max(...cleanNums);

        // If all numbers in the array are equal, prevent division by 0 (flat line guard)
        if (actualMax === actualMin) {
            actualMax = actualMin + 1;
        }

        const stepX = cleanNums.length > 1 ? svgWidth / (cleanNums.length - 1) : svgWidth;

        return cleanNums.map((val, idx) => {
            const x = startX + (idx * stepX);
            const normalized = (val - actualMin) / (actualMax - actualMin);
            // Invert Y coordinate because SVG Y starts at top (0)
            const y = maxY - (normalized * (maxY - minY));
            return `${x.toFixed(1)},${y.toFixed(1)}`;
        }).join(' ');
        },

        // Get the final endpoint dot coordinates (X, Y) for placing the circle at the end of the line
        getSparklineEndpoint(dataArray, minVal = null, maxVal = null) {
        const pointsStr = this.buildSparklinePoints(dataArray, minVal, maxVal);
        const points = pointsStr.split(' ');
        const lastPoint = points[points.length - 1].split(',');
        return {
            x: parseFloat(lastPoint[0]) || 285,
            y: parseFloat(lastPoint[1]) || 75
        };
        },

        // Calculate the dynamic X pixel offset for the vertical "AI Answering On" line based on ai_started_on month
        getAiStartedXPosition() {
        const categories = this.lineChartMetricsOptions.xaxis.categories || [];
        if (!this.ai_started_on || categories.length === 0) return 210;

        const aiMonthLabel = moment(this.ai_started_on).format('MMM');
        const index = categories.findIndex(c => c && c.includes(aiMonthLabel));

        if (index === -1) return 210;

        const svgWidth = 275;
        const startX = 10;
        const stepX = categories.length > 1 ? svgWidth / (categories.length - 1) : 0;
        return (startX + (index * stepX)).toFixed(1);
        },

        // Safely retrieve dynamic series data array by name from lineChartMetricsSeries
        getSeriesDataByName(seriesName) {
        if (!this.lineChartMetricsSeries || !Array.isArray(this.lineChartMetricsSeries)) return [];
        const found = this.lineChartMetricsSeries.find(s => s && s.name === seriesName);
        return found && Array.isArray(found.data) ? found.data : [];
        },
        getSatisfactionScoreClass(satisfaction) {
        const num = this.convertSatisfactionToNumber(satisfaction);
        const classMap = {
            5: 'score-1', // Very good
            4: 'score-2', // Good
            3: 'score-3', // Neutral
            2: 'score-4', // Bad
            1: 'score-5'  // Very bad
        };
        return classMap[num] || 'score-3';
        },
        getPerformanceScoreClass(rating) {
        const num = parseInt(rating, 10);
        const classMap = {
            5: 'score-1', // 5 -> #16a34a (Very Good - Green)
            4: 'score-2', // 4 -> #22c55e (Good - Light Green)
            3: 'score-3', // 3 -> #facc15 (Neutral - Yellow)
            2: 'score-4', // 2 -> #fb923c (Bad - Orange)
            1: 'score-5'  // 1 -> #ef4444 (Very Bad - Red)
        };
        return classMap[num] || 'info';
        },

        /* REQUEST /me/lsa-health ENDPOINT FOR DYNAMIC HEALTH HERO DATA */
        async fetchHealth() {
        if (!this.getUUID()) {
            this.loadError = 'You are signed out. Log in to view your results.';
            return;
        }
        this.loadingHealth = true;
        this.loadError = '';
        try {
            const res = await axios.get(`${process.env.VUE_APP_API_ENDPOINT}/me/lsa-health`, {
            headers: {
                Authorization: `Bearer ${this.getUUID()}`,
                'RG-Auth-Loc-Uu': this.getUUID()
            }
            });
            const d = res.data || {};
            this.businessName = d.business_name || '';
            this.period = d.period || '';
            this.healthScore = typeof d.health_score === 'number' ? d.health_score : (parseInt(d.health_score, 10) || null);
            this.healthLabel = d.health_label || '';
            this.healthSummary = d.health_summary || '';
            this.hoursSaved = d.hours_saved || '';
            this.whatWeDid = Array.isArray(d.what_we_did) ? d.what_we_did : [];
            this.setUpNext = Array.isArray(d.set_up_next) ? d.set_up_next : [];
        } catch (e) {
            this.loadError = 'We could not load your results right now. Please refresh in a moment.';
        } finally {
            this.loadingHealth = false;
        }
        },

        getTrendBadgeClass(change) {
            if (!change || change == 0) return 'flat';
            return change > 0 ? 'up' : 'down';
        },
        leadTypeIcon(item) {
          if (item.lead_type === 'PHONE_CALL') return 'mdi mdi-phone';
          if (item.lead_type === 'MESSAGE') {
            if (item.source && item.source.toLowerCase().includes('web')) return 'mdi mdi-chat';
            return 'mdi mdi-message-text';
          }
          return 'mdi mdi-briefcase';
        },

        normalizedProviders(item) {

            const src = (item.sources || '').toLowerCase();
            const leadType = (item.lead_type || '').toUpperCase();
            const list = [];

            const push = (cond, key, title, srcImg, onClick) => {
                if (cond) list.push({ key, title, src: srcImg, onClick });
            };

            // Source icon — one per lead based on where it came from
            if (src.includes('lsa')) {
                push(true, 'lsa', 'Google Local Service Ads lead', require('@/assets/images/lsa.webp'), (row) => {
                    if (row.lead_type === 'MESSAGE') this.showLsaMessagesFunction(row);
                    else this.showLsaCallRecordings(row);
                });
            } else if (src.split(',').some(source => ['google_ads', 'facebook_ads'].includes(source.trim()))) {
                const source = src.split(',').map(value => value.trim()).find(value => ['google_ads', 'facebook_ads'].includes(value));
                const provider = phoneSource(source);
                push(true, source, `${provider.label} lead`, provider.icon, null);
            } else if (src.includes('gbp')) {
                push(true, 'gbp', 'Google Business Profile lead', require('@/assets/images/reviewplatforms/icons/icon-googlemaps.png'), null);
            } else if (src.includes('yelp')) {
                push(true, 'yelp', 'Yelp lead', require('@/assets/images/reviewplatforms/icons/icon-yelp.png'), null);
            } else if (src.includes('web')) {
                if (leadType === 'MESSAGE') {
                    push(true, 'website_chat', 'Website Chat Widget lead', 'https://cdn-icons-png.flaticon.com/512/1006/1006771.png', (row) => this.showChatConversation(row));
                } else {
                    push(true, 'website_call', 'Website Call lead', 'https://cdn-icons-png.flaticon.com/512/1006/1006771.png', (row) => this.showChatConversation(row));
                }
                // Web leads are always handled by AI
                push(true, 'ai', 'This lead was responded to by AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row));
            }

            push(src.includes('callrail'), 'callrail', 'CallRail', require('@/assets/images/callrail.png'), (row) => this.showCallRailRecordingFunction(row));

            // AI icon — shown once for bland-handled non-web leads
            if (src.includes('bland') && !src.includes('web')) {
                push(true, 'ai', 'This lead was responded to by AI', require('@/assets/images/bland.png'), (row) => this.showBlandRecordingFunction(row));
            }

            push(src.includes('google_ai'), 'google_ai', 'This is a call that came in using Google AI', require('@/assets/images/review-services/www.google.com.png'), (row) => this.showChatConversation(row));

            // De-duplicate by key just in case
            const seen = new Set();
            return list.filter(p => (seen.has(p.key) ? false : seen.add(p.key)));
        },


        displayDuration(time) {
            var sec_num = time // don't forget the second param
            var hours   = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours   < 10) {hours   = "0"+hours;}
            if (minutes < 10) {minutes = "0"+minutes;}
            if (seconds < 10) {seconds = "0"+seconds;}
            return hours+':'+minutes+':'+seconds;
        },

        formatPhoneNumber(phoneNumberString) {
            const match = phoneNumberString
    .replace(/\D+/g, '').replace(/^1/, '')
    .match(/([^\d]*\d[^\d]*){1,10}$/)[0]
    const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
    const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
    const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
    return `${part1}${part2}${part3}`
        },

        playAudio(item) {
            if (document.getElementById('audio-element-wrapper-' + item.id).style.display == 'none') {
                let elements = document.getElementsByClassName('audio-element-wrapper');

                for (var i in elements) {
                    try {
                        elements[i].style.display = 'none';
                    }
                    catch (e) {}
                }

                let elements2 = document.getElementsByClassName('audio-element');

                for (var i in elements) {
                    try {
                        elements2[i].pause();
                        elements2[i].currentTime = 0;
                    }
                    catch (e) {}
                }

                let elements3 = document.getElementsByClassName('audio-element-icon');

                for (var i in elements) {
                    try {
                        elements3[i].style.display = 'block';
                    }
                    catch (e) {}
                }

                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'block';
                document.getElementById('audio-element-' + item.id).play();

                document.getElementById('audio-element-icon-' + item.id).style.display = 'none';

                
            }
            else {
                document.getElementById('audio-element-wrapper-' + item.id).style.display = 'none';
                document.getElementById('audio-element-' + item.id).pause();
                document.getElementById('audio-element-' + item.id).currentTime = 0;

                document.getElementById('audio-element-icon-' + item.id).style.display = 'block';
            }
        },

        async getMessages(silent = false) {
            let self = this;

            if (!silent)
                this.loading = true;

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-messages`, {
                date_filter: this.date_filter,
                filter_only_lsa: this.filter_calls_type === 'LSA Leads' ? 1 : 0,
                filter_calls_type: this.filter_calls_type,
                spam_missed_filter: this.spam_missed_filter,
                lead_quality_filter: this.lead_quality_filter,
                performance_filter: this.performance_filter,
                source_filter: this.source_filter
            }, {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
            })

            this.messages = response.data.messages;
            this.lsa_leads_count = response.data.lsa_leads_count;
            this.ai_leads_count = response.data.ai_leads_count;
            this.ai_leads_count_msg = response.data.ai_leads_count_msg;
            this.ai_leads_count_voice = response.data.ai_leads_count_voice;
            this.callrail_leads_count = response.data.callrail_leads_count;
            this.converted_leads_count = response.data.converted_leads_count;
            this.converted_ai_leads_count = response.data.converted_ai_leads_count;
            this.converted_human_leads_count = response.data.converted_human_leads_count;
            this.booked_leads_count = response.data.booked_leads_count;
            this.booked_ai_leads_count = response.data.booked_ai_leads_count;
            this.booked_human_leads_count = response.data.booked_human_leads_count;

            this.company_name = response.data.company_name;
            this.agency_name = response.data.agency_name;
            this.agency_logo = response.data.agency_logo;
            this.uuid = response.data.uuid;
            this.timezone = response.data.timezone;
            this.ai_started_on = response.data.ai_started_on;
            this.survey_started_on = response.data.survey_started_on;
            this.first_lead_on = response.data.first_lead_on || '';

            this.auto_survey_services = response.data.auto_survey_services;
            this.auto_survey_non_services = response.data.auto_survey_non_services;

            await this.loadDashboard();
            await this.loadDashboard2();

            this.loading = false;
            this.loadingMessages = false;
        },

        getUUID() {
          return (this.me) ? this.me.uuid : this.$route.params.uuid;
        },

        async doCreated() {
            let self = this

            self.generateMonths();
            if (this.months.length > 0) {
                this.selectedMonth = this.months[0].value;
                this.updateMonthDates(this.selectedMonth); // Set the dates for the current month
            }

            self.getMessages();
        },

        generateMonths() {
          const now = new Date();
          const result = [];

          for (let i = 0; i < 6; i++) {
            const date = new Date(
              now.getFullYear(),
              now.getMonth() - i,
              1
            );

            const value = `${date.getFullYear()}-${String(
              date.getMonth() + 1
            ).padStart(2, '0')}`;

            const label = date.toLocaleString('default', {
              month: 'short',
              year: 'numeric'
            });

            result.push({ value, label });
          }

          this.months = result;
        },

        updateMonthDates() {
          if (!this.selectedMonth) return;

          const [year, month] = this.selectedMonth.split('-');
          this.startDate = `${year}-${month}-01`;

          // Get the last day of the month
          const lastDay = new Date(year, month, 0).getDate();
          this.endDate = `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
        },

        async loadDashboard() {

            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: this.date_filter[0],
                end_date: this.date_filter[1],
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1,
                filter_only_lsa: this.filter_calls_type === 'LSA Leads' ? 1 : 0,
                filter_calls_type: this.filter_calls_type,
                lead_quality_filter: this.lead_quality_filter,
                performance_filter: this.performance_filter,
                source_filter: this.source_filter
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data = response.data.dashboard_data;
            const impactStats = response.data.dashboard_data.impact_stats || {};
            this.stats = {
              websiteChats: impactStats.websiteChats || 0,
              lsaCalls: impactStats.lsaCalls || 0,
              lsaMessages: impactStats.lsaMessages || 0,
              followUpsSent: impactStats.followUpsSent || 0,
              surveysSubmitted: impactStats.surveysSubmitted || 0,
              spamCallsBlocked: impactStats.spamCallsBlocked || 0,
              transferredCalls: impactStats.transferredCalls || 0,
              bookedAppointments: impactStats.bookedAppointments || 0,
              hoursSaved: impactStats.hoursSaved || 0
            };

            // Compute date range for previous period
            let diff_days = moment(this.date_filter[1]).diff(this.date_filter[0], 'days') + 1;
            let date_prev_start = moment(this.date_filter[0]).subtract(diff_days, 'days').format('YYYY-MM-DD');
            let date_prev_end = moment(this.date_filter[1]).subtract(diff_days, 'days').format('YYYY-MM-DD');

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency != 'Frequency: Auto') {
                date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
                date_prev_end = moment(date_prev_start).endOf('month').format('YYYY-MM-DD');
            }

            if (diff_days >= 28 && diff_days <= 31 && this.selected_frequency == 'Frequency: Auto') {
                date_prev_start = moment(this.date_filter[0]).subtract(1, 'months').format('YYYY-MM-DD');
                date_prev_end = moment(date_prev_start).add(1, 'months').format('YYYY-MM-DD');
            }

            function toBinaryStr(str) {
              const encoder = new TextEncoder();
              // 1: split the UTF-16 string into an array of bytes
              const charCodes = encoder.encode(str);
              // 2: concatenate byte data to create a binary string
              return String.fromCharCode(...charCodes);
            }

            this.reviewsScoreData = btoa(toBinaryStr(JSON.stringify(response.data.reviewsScoreData)));


            let response2 = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
                start_date: date_prev_start,
                end_date: date_prev_end,
                all_time: 0,
                selected_frequency: "Daily",
                tags_selected: '[]',
                public_survey: 1,
                filter_only_lsa: this.filter_calls_type === 'LSA Leads' ? 1 : 0,
                filter_calls_type: this.filter_calls_type,
                lead_quality_filter: this.lead_quality_filter,
                performance_filter: this.performance_filter,
                source_filter: this.source_filter
              },
              {
                headers: {
                    'RG-Auth-Loc-Uu': this.getUUID()
                }
              }
            );

            this.dashboard_data_prev = response2.data.dashboard_data;
            
            this.calculateComparisons();
          },

        
          async loadDashboard2() {
      try {
        const chartStartDate = (this.first_lead_on && moment(this.first_lead_on).isValid())
          ? moment(this.first_lead_on).format('YYYY-MM-DD')
          : moment().subtract(6, 'months').startOf('month').format('YYYY-MM-DD');

        let endDate = moment().endOf('month').format('YYYY-MM-DD');

        // if (this.selected_frequency_chart == 'Monthly') {
        //   endDate = moment().add(1, 'month').endOf('month').format('YYYY-MM-DD');
        // }

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/me/get-dashboard-data-diy`, {
            start_date: chartStartDate,
            end_date: endDate,
            all_time: 0,
            selected_frequency: this.selected_frequency_chart,
            tags_selected: '[]',
            public_survey: 1,
            filter_only_lsa: this.filter_calls_type === 'LSA Leads' ? 1 : 0,
            filter_calls_type: this.filter_calls_type,
            source_filter: this.source_filter,
            lead_quality_filter: this.lead_quality_filter,
            performance_filter: this.performance_filter
          },
          {
            headers: { 'RG-Auth-Loc-Uu': this.getUUID() }
          }
        );

        const ds = response.data.dashboard_data.metrics_chart.datasets || {};
        
        // if (this.ai_started_on) {
        //     for (var i in response.data.dashboard_data.metrics_chart.labels) {
        //         if (moment(response.data.dashboard_data.metrics_chart.labels[i]) >= moment(this.ai_started_on)) {
        //             response.data.dashboard_data.metrics_chart.labels[i] = response.data.dashboard_data.metrics_chart.labels[i];
        //         }
        //     }
        // }

        // Recreate with a coherent series/axis set. Updating axis count on the
        // old chart first makes ApexCharts read missing series during filtering.
        this.metricsChartReady = false;
        await this.$nextTick();
        const newCategories = response.data.dashboard_data.metrics_chart.labels;

        this.lineChartMetricsOptions.xaxis.categories = newCategories

        this.lineChartMetricsOptions.annotations = {
            xaxis: [
              {
                x: moment(this.ai_started_on).format('MMM YYYY'),
                borderColor: "#008FFB",
                strokeDashArray: 4,
                label: {
                  borderColor: "#008FFB",
                  style: {
                    color: "#fff",
                    background: "#008FFB"
                  },
                  text: "AI Started " + moment(this.ai_started_on).format('MM/DD')
                }
              },
            //   {
            //     x: moment(this.survey_started_on).format('MMM YYYY'),
            //     borderColor: "#FF4560",
            //     strokeDashArray: 4,
            //     label: {
            //       borderColor: "#FF4560",
            //       style: {
            //         color: "#fff",
            //         background: "#FF4560"
            //       },
            //       text: "Survey Started " + moment(this.survey_started_on).format('MM/DD')
            //     }
            //   }
            ]
          }

          console.log('this.lineChartMetricsOptions.annotations')
          console.log(JSON.stringify(this.lineChartMetricsOptions.annotations))

        // First 3 series active by default; pre-set colors/stroke so chart renders correctly
        this.activeSeriesNames = ['Under 30s Response Rate', 'Lead Volume', 'Lead Quality'];

        // Build full series list — LSA-only series are excluded when a non-LSA source is selected
        var lsaOnly = this.lsaOnlySeriesNames;
        var showLsa = this.isLsaSource;
        var allSeries = [
          {
            name: 'Under 30s Response Rate',
            data: response.data.dashboard_data.metrics_chart.datasets['Under 30s Response Rate']
          },
          {
            name: 'Lead Volume',
            data: response.data.dashboard_data.metrics_chart.datasets['Lead Volume']
          },
          {
            name: 'Lead Quality',
            data: response.data.dashboard_data.metrics_chart.datasets['Lead Quality']
          },
          {
            name: 'Impressions',
            data: response.data.dashboard_data.metrics_chart.datasets['Impressions']
          },
          {
            name: 'Absolute Top Impressions Rate',
            data: response.data.dashboard_data.metrics_chart.datasets['Absolute Top Impressions']
          },
          {
            name: 'Reviews',
            data: response.data.dashboard_data.metrics_chart.datasets['Reviews']
          },
          {
            name: 'Clicks',
            data: response.data.dashboard_data.metrics_chart.datasets['Clicks']
          },
          {
            name: 'Total Cost',
            data: response.data.dashboard_data.metrics_chart.datasets['Cost']
          },
          {
            name: 'Credited',
            data: response.data.dashboard_data.metrics_chart.datasets['Credited']
          },
          {
            name: 'CPL',
            data: response.data.dashboard_data.metrics_chart.datasets['CPL']
          }
        ];

        const conversionDatasets = response.data.dashboard_data.metrics_chart.datasets;
        ['Conversions', 'Conversion Rate', 'Collected Revenue', 'Ad-spend ROI'].forEach(name => {
          allSeries.push({ name, data: conversionDatasets[name] || [] });
        });

        // Filter out LSA-only series for non-LSA source selections
        this.lineChartMetricsSeries = showLsa
          ? allSeries
          : allSeries.filter(function(s) { return lsaOnly.indexOf(s.name) === -1; });

        // CRITICAL: yaxis must have exactly one entry per series (matched by seriesName).
        // Always filter from the FULL static yaxis config, not the already-mutated yaxis —
        // so switching back to LSA source restores all entries correctly.
        var activeSeriesNameSet = this.lineChartMetricsSeries.map(function(s) { return s.name; });
        var allYaxisConfig = [
          { seriesName: 'Under 30s Response Rate', show: false, opposite: false, min: 0, max: 100, labels: { show: false } },
          { seriesName: 'Lead Volume',              show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'Lead Quality',             show: false, opposite: false, min: 0, max: 5,   labels: { show: false } },
          { seriesName: 'Impressions',              show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'Absolute Top Impressions Rate', show: false, opposite: false, min: 0, max: 100, labels: { show: false } },
          { seriesName: 'Reviews',                  show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'Clicks',                   show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'Total Cost',               show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'Credited',                 show: false, opposite: false, min: 0,           labels: { show: false } },
          { seriesName: 'CPL',                      show: false, opposite: false, min: 0,           labels: { show: false } }
        ];
        allYaxisConfig.push(
          { seriesName: 'Conversions', show: false, min: 0, labels: { show: false } },
          { seriesName: 'Conversion Rate', show: false, min: 0, max: 100, labels: { show: false } },
          { seriesName: 'Collected Revenue', show: false, min: 0, labels: { show: false } },
          { seriesName: 'Ad-spend ROI', show: false, labels: { show: false } }
        );
        this.lineChartMetricsOptions.yaxis = allYaxisConfig.filter(function(axis) {
          return activeSeriesNameSet.indexOf(axis.seriesName) !== -1;
        });

        // Pre-set colors and stroke with correct initial visibility in one pass
        var initialActive = this.activeSeriesNames;
        this.lineChartMetricsOptions.colors = this.lineChartMetricsSeries.map(function(s, i) {
          return initialActive.indexOf(s.name) !== -1 ? (this.seriesColors[i] || '#000') : 'transparent';
        }, this);
        this.lineChartMetricsOptions.stroke = {
          curve: 'smooth',
          width: this.lineChartMetricsSeries.map(function(s) {
            return initialActive.indexOf(s.name) !== -1 ? 4 : 0;
          })
        };

        this.metricsChartReady = true;

      } catch (e) {
        console.error("Error loading historical chart metrics:", e);
      }
    },

      calculateComparison(data_now, data_previous) {
        data_now = parseFloat(data_now);
        data_previous = parseFloat(data_previous);

        if (data_now == 0 && data_previous == 0)
          return 0.00;

        if (data_now > 0 && data_previous == 0)
          return 100.00;

        if (data_now == 0 && data_previous > 0)
          return 100.00;

        let percentage;

        if (data_now > data_previous) {
          let x = (data_previous/data_now) * 100
          percentage = 100 - x;
        }
        else {
          let x = (data_now/data_previous) * 100
          percentage = 100 - x;
        }

        if (percentage <= 0)
          percentage = percentage * -1;

        percentage = percentage.toFixed(2);

        return percentage;
      },

      calculateComparisons() {
        // Charged Leads Total
        this.comparisons.charged_leads_total = this.calculateComparison(this.dashboard_data.charged_leads_total, this.dashboard_data_prev.charged_leads_total);
        // END Charged Leads Total


        // Not Charged Leads Total
        this.comparisons.not_charged_leads = this.calculateComparison(this.dashboard_data.not_charged_leads, this.dashboard_data_prev.not_charged_leads);
        // END Not Charged Leads Total


        // Total Leads
        this.comparisons.total_leads = this.calculateComparison(this.dashboard_data.total_leads, this.dashboard_data_prev.total_leads);
        // END Total Leads

        
        // Lead Quality
        this.comparisons.lead_quality = this.calculateComparison(this.dashboard_data.lead_quality, this.dashboard_data_prev.lead_quality);
        // END Lead Quality


        // Total Calls
        this.comparisons.total_calls = this.calculateComparison(this.dashboard_data.total_calls, this.dashboard_data_prev.total_calls);
        // END Total Calls


        // Total Connected Calls
        this.comparisons.total_connected_calls = this.calculateComparison(this.dashboard_data.total_connected_calls, this.dashboard_data_prev.total_connected_calls);
        // END Total Connected Calls


        // Total Message Leads
        this.comparisons.total_message_leads = this.calculateComparison(this.dashboard_data.total_message_leads, this.dashboard_data_prev.total_message_leads);
        // END Total Message Leads


        // Qualified Leads
        this.comparisons.charged_leads = this.calculateComparison(this.dashboard_data.stats.charged_leads, this.dashboard_data_prev.stats.charged_leads);
        // END Qualified Leads


        // Approved Disputes
        this.comparisons.approved_disputes = this.calculateComparison(this.dashboard_data.stats.approved_disputes, this.dashboard_data_prev.stats.approved_disputes);
        // END Approved Disputes


        // Converted Customers
        this.comparisons.converted_customers = this.calculateComparison(this.dashboard_data.stats.converted_customers, this.dashboard_data_prev.stats.converted_customers);
        // END Converted Customers

        // Converted Customers AI
        this.comparisons.converted_customers_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_ai, this.dashboard_data_prev.stats.converted_customers_ai);
        // END Converted Customers AI

        // Converted Customers NON AI
        this.comparisons.converted_customers_non_ai = this.calculateComparison(this.dashboard_data.stats.converted_customers_non_ai, this.dashboard_data_prev.stats.converted_customers_non_ai);
        // END Converted Customers NON AI


        // Conversion
        this.comparisons.conversion = this.calculateComparison(this.dashboard_data.stats.conversion, this.dashboard_data_prev.stats.conversion);
        // END Conversion


        // ROI
        this.comparisons.roi = this.calculateComparison(this.dashboard_data.stats.roi, this.dashboard_data_prev.stats.roi);
        // END ROI


        // Total Converted Value
        this.comparisons.total_converted_value = this.calculateComparison(this.dashboard_data.stats.total_converted_value, this.dashboard_data_prev.stats.total_converted_value);
        // END Total Converted Value


        // LSA Response Rate
        this.comparisons.lsa_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_response_rate, this.dashboard_data_prev.stats.lsa_response_rate);
        // END LSA Response Rate


        // LSA Response in less than 30s Rate
        this.comparisons.lsa_30_seconds_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_30_seconds_response_rate, this.dashboard_data_prev.stats.lsa_30_seconds_response_rate);
        // END LSA Response in less than 30s Rate


        // LSA Messages Average Response Rate
        this.comparisons.lsa_messages_response_rate = this.calculateComparison(this.dashboard_data.stats.lsa_messages_response_rate, this.dashboard_data_prev.stats.lsa_messages_response_rate);
        // END LSA Messages Average Response Rate


        // Total Impressions
        this.comparisons.total_impressions = this.calculateComparison(this.dashboard_data.stats.total_impressions, this.dashboard_data_prev.stats.total_impressions);
        // END Total Impressions

        // Top Impression Rate
        this.comparisons.top_impression_rate = this.calculateComparison(this.dashboard_data.stats.top_impression_rate, this.dashboard_data_prev.stats.top_impression_rate);

        // Absolute Top Impression Rate
        this.comparisons.absolute_top_impression_rate = this.calculateComparison(this.dashboard_data.stats.absolute_top_impression_rate, this.dashboard_data_prev.stats.absolute_top_impression_rate);


        // Total Clicks
        this.comparisons.total_clicks = this.calculateComparison(this.dashboard_data.stats.total_clicks, this.dashboard_data_prev.stats.total_clicks);
        // END Total Clicks


        // Total Cost
        this.comparisons.total_cost = this.calculateComparison(this.dashboard_data.stats.total_cost, this.dashboard_data_prev.stats.total_cost);
        // END Total Cost
      }
    },

    destroyed() {
        clearTimeout(this.thisProc);
        this.thisProc = null;
    },

    mounted() {
      this.logPublicView();
    },

    created() {
        this.initFromUrl();
        this.readCutoffFromQuery();
        this.fetchHealth();
        this.getMessages();
    },

    watch: {
      selectedMonth: {
        async handler(newMonth) {
          // await this.fetchLeads(newMonth);

          // this.$nextTick(() => {
          //   const hash = window.location.hash.substring(1);
          //   const params = new URLSearchParams(hash);
          //   const leadId = params.get('leadId');

          //   if (leadId) {
          //     this.openLeadWhenReady(leadId);
          //   }
          // });
        },
        immediate: true
      }
    }
}
</script>


<style scoped>
.lead-status-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 6px; margin-top: 6px; }
.qualification-row-action { display: inline-flex; align-items: center; gap: 4px; padding: 4px 6px; border-radius: 6px; font-size: 12px; color: #1d4ed8; white-space: nowrap; opacity: 0; pointer-events: none; transition: opacity .15s ease; }
.rg-datatable ::v-deep tbody tr:hover .qualification-row-action,
.rg-datatable ::v-deep tbody tr:focus-within .qualification-row-action { opacity: 1; pointer-events: auto; }
.qualification-row-action:hover { background: #eff6ff; }
.qualification-row-action:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
@media (hover: none) {
  .qualification-row-action { opacity: 1; pointer-events: auto; }
}

.customer-address {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.customer-address .mdi {
  flex-shrink: 0;
  font-size: 14px;
}

.customer-address span {
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}
 
.converted-total { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin-top: 14px; padding-top: 12px; border-top: 1px solid #e5e7eb; font-size: 12px; color: #6b7280; }
.converted-total strong { font-size: 18px; color: #1d4ed8; }

/* ================================================================= */
/* MOCKUP PROPOSAL EXACT DESIGN SYSTEM                               */
/* ================================================================= */

.lsa-modern-dashboard {
  font-family: -apple-system, "SF Pro Rounded", "Segoe UI", Nunito, sans-serif;
  /*background: #f2f5f8;*/
  color: #16283c;
  min-height: 100vh;
}

.report-brand-header {
  margin-bottom: 12px;
}

.report-agency-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 34px;
  margin-bottom: 6px;
}

.report-agency-logo {
  width: 34px;
  height: 34px;
  object-fit: contain;
  border-radius: 5px;
}

.report-agency-name {
  color: #276472;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: .08em;
  text-transform: uppercase;
}

.report-title {
  margin-bottom: 0 !important;
}

.sub {
  color: #5b6b7c;
  font-size: 13.5px;
  padding-left :0px !important;
}

.grid { display: grid; gap: 14px; }
.hero { grid-template-columns: 1.2fr 1.05fr .85fr 1.15fr; }
.cards4 { grid-template-columns: repeat(4, 1fr); }
.cards3 { grid-template-columns: repeat(3, 1fr); }

.card {
  background: #fff;
  border-radius: 14px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(22,40,60,.07);
  position: relative;
  border: 0px !important;
}

.filters-panel-card {
  background: #ffffff !important;
  border-radius: 14px;
  padding: 16px 20px;
  box-shadow: 0 1px 4px rgba(22, 40, 60, 0.08);
  border: 1px solid #e2e8f0 !important;
}

.filters-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
}

.filters-panel-card .filter-item {
  display: inline-flex;
  align-items: center;
  margin-right: 12px;
}

.filters-panel-card .filter-item:last-child {
  margin-right: 0;
}

.daterange-picker-btn {
  border: 1px solid #cbd5e1;
  background: #ffffff;
  color: #334155;
  transition: all 0.15s ease-in-out;
}

.daterange-picker-btn:hover {
  border-color: #2fa7b8;
  background-color: #f8fafc;
}

.download-csv-btn {
  background-color: #ffffff;
  border: 1px solid #cbd5e1;
  color: #1e293b;
  transition: all 0.15s ease-in-out;
}

.download-csv-btn:hover {
  border-color: #2fa7b8;
  background-color: #f8fafc;
  color: #0f172a;
}

.v-application a {
    color: #276472 !important;
}

.v-application a.text-white {
    color: #FFFFFF !important;
}

.k { font-size: 12px; color: #5b6b7c; font-weight: 700; }
.v { font-size: 28px; font-weight: 800; margin: 4px 0 6px; }
.v small { font-size: 14px; color: #5b6b7c; font-weight: 700; }

/* ================================================================= */
/* 5-LEVEL SCORE BADGE & LEGEND STYLING                              */
/* ================================================================= */

/* Legend Circle Badges */
.legend-badge {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-weight: 800;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
}

/* Base Badge Style */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
  width: fit-content;
  align-self: flex-start;
}

/* Level 5: Very Good (#16a34a) */
.legend-badge.score-1 {
  background: #15803d;
}
.badge.score-1 {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

/* Level 4: Good (#22c55e) */
.legend-badge.score-2 {
  background: #166534;
}
.badge.score-2 {
  background: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

/* Level 3: Neutral (#facc15) */
.legend-badge.score-3 {
  background: #854d0e;
}
.badge.score-3 {
  background: #fefce8;
  color: #854d0e;
  border: 1px solid #fef08a;
}

/* Level 2: Bad (#fb923c) */
.legend-badge.score-4 {
  background: #c2410c;
}
.badge.score-4 {
  background: #fff7ed;
  color: #c2410c;
  border: 1px solid #ffedd5;
}

/* Level 1: Very Bad (#ef4444) */
.legend-badge.score-5 {
  background: #b91c1c;
}
.badge.score-5 {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

/* Default Utility Badges from Proposal */
.badge.down { background: #fdecec; color: #c0392b; }
.badge.up   { background: #e8f6ee; color: #1d7a46; }
.badge.flat { background: #fff3cd; color: #8a6d08; }
.v-application .info { background: #e2eef2 !important; color: #276472 !important; }
.badge.warn { background: #fff6df; color: #9a7008; }

/* CHARGE / DISPUTE BADGE COLOR DISTINCTIONS */
.badge.charge-credited {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.badge.charge-charged {
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}

.badge.charge-not-charged {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

/* TOOLTIP STYLING PRESERVATION */
.intake-tooltip {
  max-width: 320px;
  white-space: normal;
  word-wrap: break-word;
  line-height: 1.4;
  font-size: 12px;
}

.baseline { font-size: 12px; color: #8593a3; margin-top: 6px; line-height: 1.4; }
h2.rowlabel { font-size: 12px; letter-spacing: .12em; text-transform: uppercase; color: #7a8a9b; margin: 24px 0 10px; font-weight: 800; }

/* HERO RING */
.ring {
  width: 78px;
  height: 78px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}
.ring .inner {
  width: 58px;
  height: 58px;
  border-radius: 50%;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.ring .inner b { font-size: 16px; line-height: 1; }
.ring .inner b small { font-size: 10px; color: #8593a3; }
.ring .inner span { font-size: 9px; font-weight: 800; letter-spacing: .06em; }

.why { font-size: 12px; color: #5b6b7c; margin-top: 4px; line-height: 1.4; }
.bands { display: flex; gap: 8px; margin-top: 8px; font-size: 10.5px; color: #8593a3; }
.dot { display: inline-block; width: 8px; height: 8px; border-radius: 50%; margin-right: 3px; }
.money { font-size: 24px; font-weight: 800; color: #1d7a46; }

/* ACTION & TASK CARDS */
.card.action { background: #fff8e8; border: 1.5px solid #f0d48a; }
.card.action .k { color: #9a7008; }
.cta {
  display: inline-block;
  background: #16283c;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 6px 12px;
  border-radius: 8px;
}
.cta.teal { background: #2fa7b8; }
.link { color: #276472; font-size: 12px; font-weight: 700; text-decoration: none; border-bottom: 1.5px solid #9fdbe4; }

.task { display: flex; gap: 12px; align-items: flex-start; }
.task .tag { font-size: 10px; font-weight: 800; letter-spacing: .1em; padding: 3px 6px; border-radius: 6px; }
.tag.urgent { background: #fdecec; color: #c0392b; }
.tag.disputes { background: #e2eef2; color: #276472; }
.tag.reviews { background: #eef0fb; color: #4a44a8; }
.task b { font-size: 14px; display: block; margin-bottom: 2px; }
.task p { font-size: 12px; color: #5b6b7c; line-height: 1.4; }

/* RECENT LEADS LIST (MOCKUP MATCHING DESIGN) */
.rg-lead-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ================================================================= */
/* BULLETPROOF LEAD ROW LAYOUT                                       */
/* ================================================================= */

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.card.lead-row {
  background: #ffffff;
  border-radius: 14px;
  padding: 12px 18px;
  box-shadow: 0 1px 3px rgba(22, 40, 60, 0.07);
  border: 1px solid #e2e8f0;
  margin-bottom: 10px;
  position: relative;
  display: block; /* Pure standard block box model */
  width: 100%;
}

.card.lead-row:hover {
  box-shadow: 0 4px 12px rgba(22, 40, 60, 0.10);
}

/* LEFT CONTENT CONTAINER */
.lead-left {
  float: left;
  text-align: left;
  max-width: 55%;
}

.lead-title-line {
  font-size: 14px;
  line-height: 1.3;
  color: #16283c;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.lead-name {
  font-weight: 800;
  color: #16283c;
}

.lead-type-icon {
  font-size: 16px;
  color: #64748b;
}

.provider-icons {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
}

.channel-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
  vertical-align: middle;
}

.human-icon {
  font-size: 18px;
  color: #94a3b8;
  vertical-align: middle;
}

.lead-sub-line {
  font-size: 12px;
  color: #8593a3;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

/* RIGHT CONTENT CONTAINER */
.lead-right {
  float: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 2px;
}

/* BADGES STYLING */
.badge {
  display: inline-block;
  font-size: 11.5px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 999px;
  white-space: nowrap;
}

.badge.info { background: #e2eef2; color: #276472; }

/* 5 SCORE LEVEL BADGES */
.badge.score-1 { background: #dcfce7; color: #15803d; border: 1px solid #bbf7d0; }
.badge.score-2 { background: #f0fdf4; color: #166534; border: 1px solid #bbf7d0; }
.badge.score-3 { background: #fefce8; color: #854d0e; border: 1px solid #fef08a; }
.badge.score-4 { background: #fff7ed; color: #c2410c; border: 1px solid #ffedd5; }
.badge.score-5 { background: #fef2f2; color: #b91c1c; border: 1px solid #fecaca; }

/* ACTION BUTTONS TOOLBAR */
.action-buttons {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 8px;
  border-left: 1px solid #e2e8f0;
  padding-left: 8px;
}

.icon-link {
  border: none;
  background: transparent;
  padding: 4px;
  border-radius: 6px;
  color: #5b6b7c;
  font-size: 18px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.icon-link:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.dots-btn {
  color: #64748b !important;
  cursor: pointer;
  margin-left: 4px;
}

.note-counter {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #f97316;
  color: #ffffff;
  border-radius: 999px;
  width: 13px;
  height: 13px;
  font-size: 8px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* RESPONSIVE FALLBACK */
@media (max-width: 900px) {
  .lead-left, .lead-right {
    float: none;
    max-width: 100%;
    width: 100%;
  }
  .lead-right {
    margin-top: 10px;
    justify-content: flex-start;
  }
}

/* PROPOSAL EXACT BADGE DESIGN */
.badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 999px;
  white-space: nowrap;
  width: fit-content;
}

.badge.down { background: #fdecec; color: #c0392b; }
.badge.up { background: #e8f6ee; color: #1d7a46; }
.badge.flat { background: #fff3cd; color: #8a6d08; }
.badge.info { background: #e2eef2; color: #276472; }
.badge.warn { background: #fff6df; color: #9a7008; }

/* ACTION CONTROL LINK BUTTONS */
.icon-link {
  border: 0;
  background: transparent;
  padding: 4px 6px;
  border-radius: 6px;
  color: #5b6b7c;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.icon-link:hover {
  background: #f2f5f8;
  color: #16283c;
}

.note-counter {
  position: absolute;
  top: -2px;
  right: -2px;
  background: #f97316;
  color: #fff;
  border-radius: 999px;
  width: 14px;
  height: 14px;
  font-size: 9px;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CHECKED & HIGHLIGHT STATES */
.lead--checked {
  opacity: 0.5;
  filter: grayscale(0.5);
}

.new-lead-highlight {
  background-color: #fff7cc !important;
  border-left: 4px solid #f5c518 !important;
}

@media (max-width: 900px) {
  .card.lead-row {
    flex-direction: column;
    align-items: flex-start;
  }
  .chips {
    margin-left: 0;
    width: 100%;
    justify-content: flex-start;
  }
}
.lead--checked { opacity: 0.4; filter: grayscale(0.5); }
.new-lead-highlight { background-color: #fff7cc !important; border-left: 4px solid #f5c518 !important; }

.chip.ctx { background: #e2eef2; color: #276472; font-size: 12px; font-weight: 700; padding: 4px 10px; border-radius: 999px; }
.mysterychip { border: 1.5px solid #6c63c8; color: #6c63c8; font-weight: 800; border-radius: 999px; padding: 2px 10px; font-size: 12px; }
.daterange { background: #63c6a8; color: #fff; font-weight: 700; font-size: 12.5px; padding: 8px 14px; border-radius: 10px; }

.rg-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  background: #f3f4f6;
  color: #374151;
}
.rg-pill--warn { background: rgba(245, 197, 24, 0.25); color: #92400e; }
.rg-pill--soft { background: #eef2f6; color: #374151; }

.rg-link { border: 0; background: transparent; padding: 4px; border-radius: 6px; }
.rg-link:hover { background: #f3f4f6; }

/* MODALS FIXED CSS PROPERTIES */
.rg-modal-overlay {
  position: fixed; inset: 0; z-index: 60; background: rgba(0,0,0,0.35);
  display: flex; align-items: center; justify-content: center; padding: 16px;
}
.rg-modal {
  width: min(850px, 100%); max-height: calc(100% - 32px); background: #fff;
  border-radius: 16px; overflow: hidden; box-shadow: 0 30px 70px rgba(0,0,0,0.25);
  display: flex; flex-direction: column;
}
.rg-modal__header { padding: 14px 16px; display: flex; justify-content: space-between; border-bottom: 1px solid #e5e7eb; }
.rg-modal__tabs { padding: 8px 10px; display: flex; gap: 6px; border-bottom: 1px solid #e5e7eb; background: #fafafa; }
.rg-tab { padding: 6px 12px; border-radius: 8px; font-size: 12px; font-weight: 700; color: #374151; }
.rg-tab.active { background: #fff; border: 1px solid #e5e7eb; color: #111827; }
.rg-modal__body { padding: 16px; overflow: auto; }
.rg-modal__footer { padding: 12px 16px; border-top: 1px solid #e5e7eb; display: flex; justify-content: flex-end; }
.rg-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 12px; }
.rg-kv { border: 1px solid #e5e7eb; border-radius: 10px; padding: 10px; }
.rg-k { font-size: 11px; color: #6b7280; font-weight: 700; }
.rg-v { margin-top: 2px; color: #111827; font-size: 13px; }

/* SCORE BADGES */
.legend-items { display: flex; gap: 6px; flex-wrap: wrap; }
.legend-item { display: flex; align-items: center; gap: 4px; font-size: 11px; color: #374151; }
.legend-badge { width: 18px; height: 18px; border-radius: 50%; font-weight: 700; font-size: 10px; display: flex; align-items: center; justify-content: center; color: #fff; }

.custom-legend.centered { display: flex; justify-content: center; flex-wrap: wrap; gap: 16px; }
.legend-dot { width: 10px; height: 10px; border-radius: 50%; display: inline-block; }

@media (max-width: 900px) {
  .hero, .cards4, .cards3 { grid-template-columns: 1fr 1fr; }
}
@media (max-width: 600px) {
  .hero, .cards4, .cards3 { grid-template-columns: 1fr; }
}

h2.rowlabel {
  font-size: 13px;
  letter-spacing: .12em;
  text-transform: uppercase;
  color: #7a8a9b;
  margin: 26px 0 10px;
  font-weight: 800;
}

.card {
  background: #fff;
  border-radius: 14px;
  padding: 18px 22px;
  box-shadow: 0 1px 3px rgba(22, 40, 60, .07);
  position: relative;
}

.trio {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.mini h4 {
  font-size: 12.5px;
  color: #5b6b7c;
  margin-bottom: 6px;
  font-weight: 700;
}

.mini .now {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 4px;
  color: #16283c;
}

.chartnote {
  font-size: 12px;
  color: #8593a3;
  margin-top: 12px;
  line-height: 1.4;
}

@media (max-width: 900px) {
  .trio {
    grid-template-columns: 1fr;
  }
}
</style>
